function getGraphicOrganizerData() {
  return {
    "bundles": [
      {
        "bundle_cover_image_url": "https://s3.amazonaws.com/drawp-school-canvases-new/comprehension/thumbnails/Comp_Cover.png",
        "scale": 1,
        "image_url": "https://s3.amazonaws.com/drawp-school-canvases-new/comprehension/Comp_Cover.png",
        "product_id": "COMPREHENSION_CANVAS_BUNDLE",
        "language": "en",
        "bundle_status": 0,
        "bundle_name": "Comprehension",
        "canvas_list": [
          {
            "premium": true,
            "name": "Wonder_Organizers_Charts_02_MainIdea",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-8455932153466933908-1624271053515797269/thumbnail.cdn1-8455932153466933908-1624271053515797269.png",
            "datastore_url": "https://cdn1.drawpforschool.com/assets/2575/cdn1-2575857845093031520-1623047897455819073/2040x1536/cdn1-2575857845093031520-1623047897455819073.png",
            "th": "https://cdn1.drawpforschool.com/assets/cdn1-5865353191582445015-1624430879176808810/thumbnail.cdn1-5865353191582445015-1624430879176808810.png",
            "canvas_id": "51a7e38637ba83000b001001",
            "textbox": [
              {
                "text": "Can you explain/write about your topic in the chart?",
                "left": 109.333307086614,
                "top": 32.4,
                "width": 741.322834645669,
                "height": 46.8031496062992,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto",
                "fontSize": 25.33,
                "bold": false,
                "italic": false,
                "color": "#303030"
              },
              {
                "text": "Main Idea",
                "left": 413.333307086614,
                "top": 85.2,
                "width": 146.677165354331,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#303F9F"
              },
              {
                "text": "Detail",
                "left": 121.333307086614,
                "top": 204,
                "width": 116,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "Detail",
                "left": 421.333307086614,
                "top": 204,
                "width": 116,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "Detail",
                "left": 714.666692913386,
                "top": 204,
                "width": 116,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "",
                "left": 57.3333070866142,
                "top": 121.2,
                "width": 838.677165354331,
                "height": 63.5905511811024,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 57.3333070866142,
                "top": 241.2,
                "width": 253.322834645669,
                "height": 248.409448818898,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 349.333307086614,
                "top": 241.2,
                "width": 253.322834645669,
                "height": 248.409448818898,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 644,
                "top": 241.2,
                "width": 253.322834645669,
                "height": 248.409448818898,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-8297636984104908027-1489378585900192492/cdn1-8297636984104908027-1489378585900192492.png",
            "name": "Comp_Cause_Effect",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-2482500308554996543-1624432564873486555/thumbnail.cdn1-2482500308554996543-1624432564873486555.png",
            "canvas_id": "51a7e35637ba83300a000000",
            "textbox": [
              {
                "text": "",
                "left": 28,
                "top": 114,
                "width": 373.322834645669,
                "height": 137.984251968504,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 560,
                "top": 114,
                "width": 373.322834645669,
                "height": 137.984251968504,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 28,
                "top": 361.2,
                "width": 373.322834645669,
                "height": 137.984251968504,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 560,
                "top": 361.2,
                "width": 373.322834645669,
                "height": 137.984251968504,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ],
            "slide": {
              "text": "",
              "left": 0,
              "top": 0,
              "width": 720,
              "height": 404.999921259842,
              "borderColor": "#666666",
              "borderWidth": 1,
              "borderStyle": "Dash",
              "alignment": "Left",
              "fontName": "Calibri",
              "fontSize": 18,
              "bold": false,
              "italic": false,
              "color": "#44546A"
            }
          },
          {
            "premium": true,
            "name": "Wonder_Organizers_Charts_03_Conclusion",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-7743136639799008458-1624271218252923264/thumbnail.cdn1-7743136639799008458-1624271218252923264.png",
            "datastore_url": "https://cdn1.drawpforschool.com/assets/6138/cdn1-6138287476218947543-1623047908049695078/2040x1536/cdn1-6138287476218947543-1623047908049695078.png",
            "th": "https://cdn1.drawpforschool.com/assets/cdn1-8189797702100512011-1624432707425414776/thumbnail.cdn1-8189797702100512011-1624432707425414776.png",
            "canvas_id": "51a7e38637ba83000b001002",
            "textbox": [
              {
                "text": "Can you draw a conclusion based on facts?",
                "left": 109.333307086614,
                "top": 32.4,
                "width": 741.322834645669,
                "height": 46.8031496062992,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto",
                "fontSize": 25.33,
                "bold": false,
                "italic": false,
                "color": "#303030"
              },
              {
                "text": "Conclusion",
                "left": 420,
                "top": 375.6,
                "width": 121.322834645669,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#303F9F"
              },
              {
                "text": "Fact",
                "left": 140,
                "top": 79.2,
                "width": 77.3228346456693,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "Fact",
                "left": 441.333307086614,
                "top": 79.2,
                "width": 77.3228346456693,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "Fact",
                "left": 738.666692913386,
                "top": 79.2,
                "width": 77.3228346456693,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "",
                "left": 57.3333070866142,
                "top": 415.2,
                "width": 838.677165354331,
                "height": 84,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 57.3333070866142,
                "top": 111.6,
                "width": 253.322834645669,
                "height": 219.590551181102,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 350.666692913386,
                "top": 111.6,
                "width": 253.322834645669,
                "height": 219.590551181102,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 644,
                "top": 111.6,
                "width": 253.322834645669,
                "height": 219.590551181102,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-3203645749228009632-1489378585872045855/cdn1-3203645749228009632-1489378585872045855.png",
            "name": "Comp_Fact_Opin",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-5971399099882518131-1624432806394533818/thumbnail.cdn1-5971399099882518131-1624432806394533818.png",
            "canvas_id": "51a7e36837ba830309000000",
            "textbox": [
              {
                "text": "",
                "left": 33.3333070866142,
                "top": 21.6,
                "width": 879.338582677165,
                "height": 62.992125984252,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 36,
                "top": 144,
                "width": 412.787401574803,
                "height": 98.488188976378,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 501.333307086614,
                "top": 144,
                "width": 412.787401574803,
                "height": 98.488188976378,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 36,
                "top": 259.2,
                "width": 412.787401574803,
                "height": 106.204724409449,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 501.333307086614,
                "top": 259.2,
                "width": 412.787401574803,
                "height": 106.204724409449,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 36,
                "top": 389.664015748031,
                "width": 412.787401574803,
                "height": 122.677165354331,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 501.333307086614,
                "top": 389.664015748031,
                "width": 412.787401574803,
                "height": 122.677165354331,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "premium": true,
            "name": "Wonder_Organizers_Charts_04_Prediction",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-5358252431696607013-1624271310630733862/thumbnail.cdn1-5358252431696607013-1624271310630733862.png",
            "datastore_url": "https://cdn1.drawpforschool.com/assets/8323/cdn1-8323634353174561082-1623047903508560734/2040x1536/cdn1-8323634353174561082-1623047903508560734.png",
            "th": "https://cdn1.drawpforschool.com/assets/cdn1-2965655771243473099-1624432929038871191/thumbnail.cdn1-2965655771243473099-1624432929038871191.png",
            "canvas_id": "51a7e38637ba83000b001003",
            "textbox": [
              {
                "text": "Can you predict what happens?",
                "left": 109.333307086614,
                "top": 32.4,
                "width": 741.322834645669,
                "height": 46.8031496062992,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto",
                "fontSize": 25.33,
                "bold": false,
                "italic": false,
                "color": "#303030"
              },
              {
                "text": "What Happens",
                "left": 636,
                "top": 94.8,
                "width": 160,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#303F9F"
              },
              {
                "text": "What I Predict",
                "left": 166.666692913386,
                "top": 94.8,
                "width": 152,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "",
                "left": 57.3333070866142,
                "top": 145.2,
                "width": 384,
                "height": 345.606299212598,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 521.333307086614,
                "top": 145.2,
                "width": 384,
                "height": 345.606299212598,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-1973466865019076159-1489378586047002225/cdn1-1973466865019076159-1489378586047002225.png",
            "name": "Comp_Persuation",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-8684823899488961210-1624433008401298970/thumbnail.cdn1-8684823899488961210-1624433008401298970.png",
            "canvas_id": "51a7e37b37ba830009300001",
            "textbox": [
              {
                "text": "",
                "left": 24,
                "top": 184.032047244094,
                "width": 257.291338582677,
                "height": 187.496062992126,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 344.64,
                "top": 19.8720472440945,
                "width": 200.629921259843,
                "height": 142.551181102362,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 344.64,
                "top": 201.312047244094,
                "width": 200.629921259843,
                "height": 142.551181102362,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 344.64,
                "top": 383.615984251968,
                "width": 200.629921259843,
                "height": 142.551181102362,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 607.68,
                "top": 17.28,
                "width": 312,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 607.68,
                "top": 74.3040157480315,
                "width": 312,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 607.68,
                "top": 131.327952755905,
                "width": 312,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 607.68,
                "top": 194.4,
                "width": 312,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 607.68,
                "top": 252.287952755906,
                "width": 312,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 607.68,
                "top": 310.175984251968,
                "width": 312,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 607.68,
                "top": 375.84,
                "width": 312,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 607.68,
                "top": 432,
                "width": 312,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 607.68,
                "top": 487.295984251968,
                "width": 312,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "premium": true,
            "name": "Wonder_Organizers_Charts_05_CauseEffect",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-5487829669153940599-1624271435024843918/thumbnail.cdn1-5487829669153940599-1624271435024843918.png",
            "datastore_url": "https://cdn1.drawpforschool.com/assets/3533/cdn1-3533010280253072312-1623047906246732673/2040x1536/cdn1-3533010280253072312-1623047906246732673.png",
            "th": "https://cdn1.drawpforschool.com/assets/cdn1-9146254869491577795-1624433101588402859/thumbnail.cdn1-9146254869491577795-1624433101588402859.png",
            "canvas_id": "51a7e38637ba83000b001004",
            "textbox": [
              {
                "text": "Can you explain/write the cause and effect?",
                "left": 109.333307086614,
                "top": 32.4,
                "width": 741.322834645669,
                "height": 46.8031496062992,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto",
                "fontSize": 25.33,
                "bold": false,
                "italic": false,
                "color": "#303030"
              },
              {
                "text": "Effect",
                "left": 670.666692913386,
                "top": 94.8,
                "width": 96,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#303F9F"
              },
              {
                "text": "Cause",
                "left": 188,
                "top": 94.8,
                "width": 96,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "",
                "left": 44,
                "top": 132,
                "width": 384,
                "height": 345.606299212598,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 526.666692913386,
                "top": 132,
                "width": 384,
                "height": 345.606299212598,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-3036102378789001046-1489378586058259157/cdn1-3036102378789001046-1489378586058259157.png",
            "name": "Comp_Table_KWL",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-4421843782073868914-1624433250582367102/thumbnail.cdn1-4421843782073868914-1624433250582367102.png",
            "canvas_id": "51a7e38637ba83000b000300",
            "textbox": [
              {
                "text": "",
                "left": 22.6666929133858,
                "top": 48.3840157480315,
                "width": 285.133858267717,
                "height": 473.48031496063,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 337.333307086614,
                "top": 48.3840157480315,
                "width": 285.133858267717,
                "height": 473.48031496063,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 653.333307086614,
                "top": 48.3840157480315,
                "width": 285.133858267717,
                "height": 473.48031496063,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "premium": true,
            "name": "Wonder_Organizers_Charts_08_Inferences",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-8032986566966368616-1624271517313024812/thumbnail.cdn1-8032986566966368616-1624271517313024812.png",
            "datastore_url": "https://cdn1.drawpforschool.com/assets/9035/cdn1-9035571337414627925-1623047895825027802/2040x1536/cdn1-9035571337414627925-1623047895825027802.png",
            "th": "https://cdn1.drawpforschool.com/assets/cdn1-7357897091275832416-1624433395959778585/thumbnail.cdn1-7357897091275832416-1624433395959778585.png",
            "canvas_id": "51a7e38637ba83000b001007",
            "textbox": [
              {
                "text": "What inferences can you draw based on the text?",
                "left": 109.333307086614,
                "top": 32.4,
                "width": 741.322834645669,
                "height": 46.8031496062992,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto",
                "fontSize": 25.33,
                "bold": false,
                "italic": false,
                "color": "#303030"
              },
              {
                "text": "My Inferences",
                "left": 350.666692913386,
                "top": 376.8,
                "width": 260,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#303F9F"
              },
              {
                "text": "What I Know",
                "left": 181.333307086614,
                "top": 79.2,
                "width": 132,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "What I Read",
                "left": 641.333307086614,
                "top": 79.2,
                "width": 132,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "",
                "left": 56,
                "top": 117.6,
                "width": 384,
                "height": 211.212598425197,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 516,
                "top": 117.6,
                "width": 384,
                "height": 211.212598425197,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 48,
                "top": 411.6,
                "width": 858.677165354331,
                "height": 92.4094488188976,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-518722876803473451-1489378585636593765/cdn1-518722876803473451-1489378585636593765.png",
            "name": "Comp_Vocabulary_Chart",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-1111338860536789242-1624433506530549024/thumbnail.cdn1-1111338860536789242-1624433506530549024.png",
            "canvas_id": "51a7e39337ba830009003002",
            "textbox": [
              {
                "text": "",
                "left": 22.6666929133858,
                "top": 32.8320472440945,
                "width": 303.370078740157,
                "height": 76.8818897637795,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 22.6666929133858,
                "top": 149.472047244094,
                "width": 303.370078740157,
                "height": 169.354330708661,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 359.04,
                "top": 33.6959842519685,
                "width": 576.944881889764,
                "height": 285.133858267717,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "premium": true,
            "name": "Wonder_Organizers_Charts_09_AuthorsPurpose",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-125885844349692999-1624271616746991249/thumbnail.cdn1-125885844349692999-1624271616746991249.png",
            "datastore_url": "https://cdn1.drawpforschool.com/assets/9035/cdn1-9035818663819516660-1623236731813932857/2040x1536/cdn1-9035818663819516660-1623236731813932857.png",
            "th": "https://cdn1.drawpforschool.com/assets/cdn1-379126037342803928-1624433616355514075/thumbnail.cdn1-379126037342803928-1624433616355514075.png",
            "canvas_id": "51a7e38637ba83000b001008",
            "textbox": [
              {
                "text": "Can you explain/write about the author’s purpose?",
                "left": 109.333307086614,
                "top": 32.4,
                "width": 741.322834645669,
                "height": 46.8031496062992,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto",
                "fontSize": 25.33,
                "bold": false,
                "italic": false,
                "color": "#303030"
              },
              {
                "text": "Author’s Purpose",
                "left": 386.666692913386,
                "top": 79.2,
                "width": 181.322834645669,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#303F9F"
              },
              {
                "text": "Evidence",
                "left": 181.333307086614,
                "top": 295.2,
                "width": 184,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "Evidence",
                "left": 641.333307086614,
                "top": 295.2,
                "width": 184,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "",
                "left": 56,
                "top": 333.6,
                "width": 384,
                "height": 165.606299212598,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 516,
                "top": 333.6,
                "width": 384,
                "height": 165.606299212598,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 48,
                "top": 117.6,
                "width": 858.677165354331,
                "height": 121.196850393701,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "premium": true,
            "name": "Wonder_Organizers_Charts_10_ProblemSolution",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-3382436494004277439-1624271665172343381/thumbnail.cdn1-3382436494004277439-1624271665172343381.png",
            "datastore_url": "https://cdn1.drawpforschool.com/assets/3564/cdn1-3564228363517363998-1623047898459875365/2040x1536/cdn1-3564228363517363998-1623047898459875365.png",
            "th": "https://cdn1.drawpforschool.com/assets/cdn1-3940058941797717214-1624433679384988927/thumbnail.cdn1-3940058941797717214-1624433679384988927.png",
            "canvas_id": "51a7e38637ba83000b001009",
            "textbox": [
              {
                "text": "How to solve the problem?",
                "left": 109.333307086614,
                "top": 32.4,
                "width": 741.322834645669,
                "height": 46.8031496062992,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto",
                "fontSize": 25.33,
                "bold": false,
                "italic": false,
                "color": "#303030"
              },
              {
                "text": "Solution",
                "left": 692,
                "top": 90,
                "width": 166.677165354331,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#303F9F"
              },
              {
                "text": "What is needed",
                "left": 384,
                "top": 172.8,
                "width": 182.677165354331,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "Problem",
                "left": 90.6666929133858,
                "top": 270,
                "width": 166.677165354331,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#303030"
              },
              {
                "text": "",
                "left": 61.3333070866142,
                "top": 302.4,
                "width": 232,
                "height": 196.787401574803,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 354.666692913386,
                "top": 211.2,
                "width": 241.322834645669,
                "height": 288,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 649.333307086614,
                "top": 127.2,
                "width": 252,
                "height": 372,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "premium": true,
            "name": "Wonder_Organizers_Charts_11_CharacterSetting",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-6415857937854634387-1624271718136847333/thumbnail.cdn1-6415857937854634387-1624271718136847333.png",
            "datastore_url": "https://cdn1.drawpforschool.com/assets/1836/cdn1-1836882615449568934-1623047901332389509/2040x1536/cdn1-1836882615449568934-1623047901332389509.png",
            "th": "https://cdn1.drawpforschool.com/assets/cdn1-420566084593299340-1624433959736265176/thumbnail.cdn1-420566084593299340-1624433959736265176.png",
            "canvas_id": "51a7e38637ba83000b001099",
            "textbox": [
              {
                "text": "Can you find similarities and differences?",
                "left": 109.333307086614,
                "top": 32.4,
                "width": 741.322834645669,
                "height": 46.8031496062992,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto",
                "fontSize": 25.33,
                "bold": false,
                "italic": false,
                "color": "#303030"
              },
              {
                "text": "Same",
                "left": 396,
                "top": 115.2,
                "width": 166.677165354331,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#303F9F"
              },
              {
                "text": "Different",
                "left": 160,
                "top": 115.2,
                "width": 166.677165354331,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "Different",
                "left": 626.666692913386,
                "top": 115.2,
                "width": 166.677165354331,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "",
                "left": 68,
                "top": 172.8,
                "width": 216,
                "height": 249.606299212598,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 677.333307086614,
                "top": 172.8,
                "width": 216,
                "height": 249.606299212598,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 360,
                "top": 168,
                "width": 241.322834645669,
                "height": 258.015748031496,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          }
        ],
        "id": "1",
        "free": "False"
      },
      {
        "bundle_cover_image_url": "https://s3.amazonaws.com/drawp-school-canvases-new/comprehension/thumbnails/Comp_Cover_es.png",
        "scale": 1,
        "image_url": "https://s3.amazonaws.com/drawp-school-canvases-new/comprehension/Comp_Cover_es.png",
        "product_id": "COMPREHENSION_CANVAS_BUNDLE",
        "language": "es",
        "bundle_status": 0,
        "bundle_name": "Comprehension",
        "canvas_list": [
          {
            "premium": true,
            "name": "Wonder_Organizers_Charts_02_MainIdea",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-3470818259474784518-1624337808771553518/thumbnail.cdn1-3470818259474784518-1624337808771553518.png",
            "datastore_url": "https://cdn1.drawpforschool.com/assets/2575/cdn1-2575857845093031520-1623047897455819073/2040x1536/cdn1-2575857845093031520-1623047897455819073.png",
            "th": "https://cdn1.drawpforschool.com/assets/cdn1-5865353191582445015-1624430879176808810/thumbnail.cdn1-5865353191582445015-1624430879176808810.png",
            "canvas_id": "51a7e38637ba83000b001299",
            "textbox": [
              {
                "text": "¿Puedes explicar/escribir acerca de tu tema en el gráfico?",
                "left": 109.333307086614,
                "top": 32.4,
                "width": 741.322834645669,
                "height": 46.8031496062992,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto",
                "fontSize": 25.33,
                "bold": false,
                "italic": false,
                "color": "#303030"
              },
              {
                "text": "Idea Principal",
                "left": 413.333307086614,
                "top": 85.2,
                "width": 146.677165354331,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#303F9F"
              },
              {
                "text": "Detalle",
                "left": 121.333307086614,
                "top": 204,
                "width": 116,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "Detalle",
                "left": 421.333307086614,
                "top": 204,
                "width": 116,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "Detalle",
                "left": 714.666692913386,
                "top": 204,
                "width": 116,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "",
                "left": 57.3333070866142,
                "top": 121.2,
                "width": 838.677165354331,
                "height": 63.5905511811024,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 57.3333070866142,
                "top": 241.2,
                "width": 253.322834645669,
                "height": 248.409448818898,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 349.333307086614,
                "top": 241.2,
                "width": 253.322834645669,
                "height": 248.409448818898,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 644,
                "top": 241.2,
                "width": 253.322834645669,
                "height": 248.409448818898,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-3867693114681683314-1489378590988215544/cdn1-3867693114681683314-1489378590988215544.png",
            "name": "Comp_Cause_Effect_es",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-2918251928003231859-1624432630755717852/thumbnail.cdn1-2918251928003231859-1624432630755717852.png",
            "canvas_id": "51a7e35637ba83300a000011",
            "textbox": [
              {
                "text": "",
                "left": 28,
                "top": 114,
                "width": 373.322834645669,
                "height": 137.984251968504,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 560,
                "top": 114,
                "width": 373.322834645669,
                "height": 137.984251968504,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 28,
                "top": 361.2,
                "width": 373.322834645669,
                "height": 137.984251968504,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 560,
                "top": 361.2,
                "width": 373.322834645669,
                "height": 137.984251968504,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "premium": true,
            "name": "Wonder_Organizers_Charts_03_Conclusion",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-2679651039342810714-1624337884747551475/thumbnail.cdn1-2679651039342810714-1624337884747551475.png",
            "datastore_url": "https://cdn1.drawpforschool.com/assets/6138/cdn1-6138287476218947543-1623047908049695078/2040x1536/cdn1-6138287476218947543-1623047908049695078.png",
            "th": "https://cdn1.drawpforschool.com/assets/cdn1-8189797702100512011-1624432707425414776/thumbnail.cdn1-8189797702100512011-1624432707425414776.png",
            "canvas_id": "51a7e38637ba83000b001399",
            "textbox": [
              {
                "text": "¿Puedes escribir una conclusión basada en hechos?",
                "left": 109.333307086614,
                "top": 32.4,
                "width": 741.322834645669,
                "height": 46.8031496062992,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto",
                "fontSize": 25.33,
                "bold": false,
                "italic": false,
                "color": "#303030"
              },
              {
                "text": "Conclusión",
                "left": 420,
                "top": 375.6,
                "width": 121.322834645669,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#303F9F"
              },
              {
                "text": "Hecho",
                "left": 140,
                "top": 79.2,
                "width": 77.3228346456693,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "Hecho",
                "left": 441.333307086614,
                "top": 79.2,
                "width": 77.3228346456693,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "Hecho",
                "left": 738.666692913386,
                "top": 79.2,
                "width": 77.3228346456693,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "",
                "left": 57.3333070866142,
                "top": 415.2,
                "width": 838.677165354331,
                "height": 84,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 57.3333070866142,
                "top": 111.6,
                "width": 253.322834645669,
                "height": 219.590551181102,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 350.666692913386,
                "top": 111.6,
                "width": 253.322834645669,
                "height": 219.590551181102,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 644,
                "top": 111.6,
                "width": 253.322834645669,
                "height": 219.590551181102,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-6610208976787309291-1489378593099294435/cdn1-6610208976787309291-1489378593099294435.png",
            "name": "Comp_Fact_Opin_es",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-642023956575621798-1624432850128201568/thumbnail.cdn1-642023956575621798-1624432850128201568.png",
            "canvas_id": "51a7e36837ba830309000012",
            "textbox": [
              {
                "text": "",
                "left": 33.3333070866142,
                "top": 21.6,
                "width": 879.338582677165,
                "height": 62.992125984252,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 36,
                "top": 144,
                "width": 412.787401574803,
                "height": 98.488188976378,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 501.333307086614,
                "top": 144,
                "width": 412.787401574803,
                "height": 98.488188976378,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 36,
                "top": 259.2,
                "width": 412.787401574803,
                "height": 106.204724409449,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 501.333307086614,
                "top": 259.2,
                "width": 412.787401574803,
                "height": 106.204724409449,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 36,
                "top": 389.664015748031,
                "width": 412.787401574803,
                "height": 122.677165354331,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 501.333307086614,
                "top": 389.664015748031,
                "width": 412.787401574803,
                "height": 122.677165354331,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "premium": true,
            "name": "Wonder_Organizers_Charts_04_Prediction",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-3056852583702449688-1624337985437374929/thumbnail.cdn1-3056852583702449688-1624337985437374929.png",
            "datastore_url": "https://cdn1.drawpforschool.com/assets/8323/cdn1-8323634353174561082-1623047903508560734/2040x1536/cdn1-8323634353174561082-1623047903508560734.png",
            "th": "https://cdn1.drawpforschool.com/assets/cdn1-2965655771243473099-1624432929038871191/thumbnail.cdn1-2965655771243473099-1624432929038871191.png",
            "canvas_id": "51a7e38637ba83000b001499",
            "textbox": [
              {
                "text": "¿Puedes predecir lo que va a suceder?",
                "left": 109.333307086614,
                "top": 32.4,
                "width": 741.322834645669,
                "height": 46.8031496062992,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto",
                "fontSize": 25.33,
                "bold": false,
                "italic": false,
                "color": "#303030"
              },
              {
                "text": "Lo que sucede",
                "left": 636,
                "top": 94.8,
                "width": 160,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#303F9F"
              },
              {
                "text": "Mi predicción",
                "left": 166.666692913386,
                "top": 94.8,
                "width": 152,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "",
                "left": 57.3333070866142,
                "top": 145.2,
                "width": 384,
                "height": 345.606299212598,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 521.333307086614,
                "top": 145.2,
                "width": 384,
                "height": 345.606299212598,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-8413485650405410670-1489378585971832229/cdn1-8413485650405410670-1489378585971832229.png",
            "name": "Comp_Persuation",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-8684823899488961210-1624433008401298970/thumbnail.cdn1-8684823899488961210-1624433008401298970.png",
            "canvas_id": "51a7e37b37ba830009300013",
            "textbox": [
              {
                "text": "",
                "left": 24,
                "top": 184.032047244094,
                "width": 257.291338582677,
                "height": 187.496062992126,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 344.64,
                "top": 19.8720472440945,
                "width": 200.629921259843,
                "height": 142.551181102362,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 344.64,
                "top": 201.312047244094,
                "width": 200.629921259843,
                "height": 142.551181102362,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 344.64,
                "top": 383.615984251968,
                "width": 200.629921259843,
                "height": 142.551181102362,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 607.68,
                "top": 17.28,
                "width": 312,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 607.68,
                "top": 74.3040157480315,
                "width": 312,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 607.68,
                "top": 131.327952755905,
                "width": 312,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 607.68,
                "top": 194.4,
                "width": 312,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 607.68,
                "top": 252.287952755906,
                "width": 312,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 607.68,
                "top": 310.175984251968,
                "width": 312,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 607.68,
                "top": 375.84,
                "width": 312,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 607.68,
                "top": 432,
                "width": 312,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 607.68,
                "top": 487.295984251968,
                "width": 312,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "premium": true,
            "name": "Wonder_Organizers_Charts_05_CauseEffect",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-8212814485509400137-1624338060391280203/thumbnail.cdn1-8212814485509400137-1624338060391280203.png",
            "datastore_url": "https://cdn1.drawpforschool.com/assets/3533/cdn1-3533010280253072312-1623047906246732673/2040x1536/cdn1-3533010280253072312-1623047906246732673.png",
            "th": "https://cdn1.drawpforschool.com/assets/cdn1-9146254869491577795-1624433101588402859/thumbnail.cdn1-9146254869491577795-1624433101588402859.png",
            "canvas_id": "51a7e38637ba83000b001599",
            "textbox": [
              {
                "text": "¿Puedes describir las causas y efectos?",
                "left": 109.333307086614,
                "top": 32.4,
                "width": 741.322834645669,
                "height": 46.8031496062992,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto",
                "fontSize": 25.33,
                "bold": false,
                "italic": false,
                "color": "#303030"
              },
              {
                "text": "Efectos",
                "left": 670.666692913386,
                "top": 94.8,
                "width": 96,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#303F9F"
              },
              {
                "text": "Causas",
                "left": 188,
                "top": 94.8,
                "width": 96,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "",
                "left": 44,
                "top": 132,
                "width": 384,
                "height": 345.606299212598,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 526.666692913386,
                "top": 132,
                "width": 384,
                "height": 345.606299212598,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-363139539224016034-1489378595851813071/cdn1-363139539224016034-1489378595851813071.png",
            "name": "Comp_Table_KWL_es",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-6124822084467887408-1624433321274618268/thumbnail.cdn1-6124822084467887408-1624433321274618268.png",
            "canvas_id": "51a7e38637ba83000b000314",
            "textbox": [
              {
                "text": "",
                "left": 22.6666929133858,
                "top": 48.3840157480315,
                "width": 285.133858267717,
                "height": 473.48031496063,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 337.333307086614,
                "top": 48.3840157480315,
                "width": 285.133858267717,
                "height": 473.48031496063,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 653.333307086614,
                "top": 48.3840157480315,
                "width": 285.133858267717,
                "height": 473.48031496063,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "premium": true,
            "name": "Wonder_Organizers_Charts_08_Inferences",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-485738521661741253-1624338169446480844/thumbnail.cdn1-485738521661741253-1624338169446480844.png",
            "datastore_url": "https://cdn1.drawpforschool.com/assets/9035/cdn1-9035571337414627925-1623047895825027802/2040x1536/cdn1-9035571337414627925-1623047895825027802.png",
            "th": "https://cdn1.drawpforschool.com/assets/cdn1-7357897091275832416-1624433395959778585/thumbnail.cdn1-7357897091275832416-1624433395959778585.png",
            "canvas_id": "51a7e38637ba83000b001899",
            "textbox": [
              {
                "text": "¿Cuáles deducciones puedes inferir basadas en el escrito?",
                "left": 109.333307086614,
                "top": 32.4,
                "width": 741.322834645669,
                "height": 46.8031496062992,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto",
                "fontSize": 25.33,
                "bold": false,
                "italic": false,
                "color": "#303030"
              },
              {
                "text": "Mis inferencias/deducciones",
                "left": 350.666692913386,
                "top": 376.8,
                "width": 260,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#303F9F"
              },
              {
                "text": "Lo que sé",
                "left": 181.333307086614,
                "top": 79.2,
                "width": 132,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "Lo que leí",
                "left": 641.333307086614,
                "top": 79.2,
                "width": 132,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "",
                "left": 56,
                "top": 117.6,
                "width": 384,
                "height": 211.212598425197,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 516,
                "top": 117.6,
                "width": 384,
                "height": 211.212598425197,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 48,
                "top": 411.6,
                "width": 858.677165354331,
                "height": 92.4094488188976,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-4138947303600346038-1489378597155142487/cdn1-4138947303600346038-1489378597155142487.png",
            "name": "Comp_Vocabulary_Chart_es",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-7982332448637464156-1624433557695923262/thumbnail.cdn1-7982332448637464156-1624433557695923262.png",
            "canvas_id": "51a7e39337ba830009003015",
            "textbox": [
              {
                "text": "",
                "left": 22.6666929133858,
                "top": 32.8320472440945,
                "width": 303.370078740157,
                "height": 76.8818897637795,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 22.6666929133858,
                "top": 149.472047244094,
                "width": 303.370078740157,
                "height": 169.354330708661,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 359.04,
                "top": 33.6959842519685,
                "width": 576.944881889764,
                "height": 285.133858267717,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "premium": true,
            "name": "Wonder_Organizers_Charts_09_AuthorsPurpose",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-6229468593416577480-1624338256700758358/thumbnail.cdn1-6229468593416577480-1624338256700758358.png",
            "datastore_url": "https://cdn1.drawpforschool.com/assets/9035/cdn1-9035818663819516660-1623236731813932857/2040x1536/cdn1-9035818663819516660-1623236731813932857.png",
            "th": "https://cdn1.drawpforschool.com/assets/cdn1-379126037342803928-1624433616355514075/thumbnail.cdn1-379126037342803928-1624433616355514075.png",
            "canvas_id": "51a7e38637ba83000b001999",
            "textbox": [
              {
                "text": "¿Puedes explicar/escribir acerca del propósito del autor?",
                "left": 109.333307086614,
                "top": 32.4,
                "width": 741.322834645669,
                "height": 46.8031496062992,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto",
                "fontSize": 25.33,
                "bold": false,
                "italic": false,
                "color": "#303030"
              },
              {
                "text": "Propósito del Autor",
                "left": 386.666692913386,
                "top": 79.2,
                "width": 181.322834645669,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#303F9F"
              },
              {
                "text": "Evidencia",
                "left": 181.333307086614,
                "top": 295.2,
                "width": 184,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "Evidencia",
                "left": 641.333307086614,
                "top": 295.2,
                "width": 184,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "",
                "left": 56,
                "top": 333.6,
                "width": 384,
                "height": 165.606299212598,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 516,
                "top": 333.6,
                "width": 384,
                "height": 165.606299212598,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 48,
                "top": 117.6,
                "width": 858.677165354331,
                "height": 121.196850393701,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "premium": true,
            "name": "Wonder_Organizers_Charts_10_ProblemSolution",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-920503339792535312-1624338294981341916/thumbnail.cdn1-920503339792535312-1624338294981341916.png",
            "datastore_url": "https://cdn1.drawpforschool.com/assets/3564/cdn1-3564228363517363998-1623047898459875365/2040x1536/cdn1-3564228363517363998-1623047898459875365.png",
            "th": "https://cdn1.drawpforschool.com/assets/cdn1-3940058941797717214-1624433679384988927/thumbnail.cdn1-3940058941797717214-1624433679384988927.png",
            "canvas_id": "51a7e38637ba83000b001998",
            "textbox": [
              {
                "text": "¿Cómo se puede resolver el problema?",
                "left": 109.333307086614,
                "top": 32.4,
                "width": 741.322834645669,
                "height": 46.8031496062992,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto",
                "fontSize": 25.33,
                "bold": false,
                "italic": false,
                "color": "#303030"
              },
              {
                "text": "Solución",
                "left": 692,
                "top": 90,
                "width": 166.677165354331,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#303F9F"
              },
              {
                "text": "Lo que se necesita",
                "left": 384,
                "top": 172.8,
                "width": 182.677165354331,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "Problema",
                "left": 90.6666929133858,
                "top": 270,
                "width": 166.677165354331,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#303030"
              },
              {
                "text": "",
                "left": 61.3333070866142,
                "top": 302.4,
                "width": 232,
                "height": 196.787401574803,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 354.666692913386,
                "top": 211.2,
                "width": 241.322834645669,
                "height": 288,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 649.333307086614,
                "top": 127.2,
                "width": 252,
                "height": 372,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "premium": true,
            "name": "Wonder_Organizers_Charts_11_CharacterSetting",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-150437370412394460-1624338325981564559/thumbnail.cdn1-150437370412394460-1624338325981564559.png",
            "datastore_url": "https://cdn1.drawpforschool.com/assets/1836/cdn1-1836882615449568934-1623047901332389509/2040x1536/cdn1-1836882615449568934-1623047901332389509.png",
            "th": "https://cdn1.drawpforschool.com/assets/cdn1-420566084593299340-1624433959736265176/thumbnail.cdn1-420566084593299340-1624433959736265176.png",
            "canvas_id": "51a7e38637ba83000b001997",
            "textbox": [
              {
                "text": "¿Puedes encontrar semejanzas y diferencias?",
                "left": 109.333307086614,
                "top": 32.4,
                "width": 741.322834645669,
                "height": 46.8031496062992,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto",
                "fontSize": 25.33,
                "bold": false,
                "italic": false,
                "color": "#303030"
              },
              {
                "text": "Igual",
                "left": 396,
                "top": 115.2,
                "width": 166.677165354331,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#303F9F"
              },
              {
                "text": "Diferente",
                "left": 160,
                "top": 115.2,
                "width": 166.677165354331,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "Diferente",
                "left": 626.666692913386,
                "top": 115.2,
                "width": 166.677165354331,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "",
                "left": 68,
                "top": 172.8,
                "width": 216,
                "height": 249.606299212598,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 677.333307086614,
                "top": 172.8,
                "width": 216,
                "height": 249.606299212598,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 360,
                "top": 168,
                "width": 241.322834645669,
                "height": 258.015748031496,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          }
        ],
        "id": "1",
        "free": "False"
      },
      {
        "bundle_cover_image_url": "https://s3.amazonaws.com/drawp-school-canvases-new/story/thumbnails/Story_Cover.png",
        "scale": 1,
        "image_url": "https://s3.amazonaws.com/drawp-school-canvases-new/story/Story_Cover.png",
        "product_id": "STORY_CANVAS_BUNDLE",
        "language": "en",
        "bundle_status": 0,
        "bundle_name": "Story",
        "canvas_list": [
          {
            "premium": true,
            "name": "Wonder_Organizers_Charts_01_Setting",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-371016627628904547-1624271876642360718/thumbnail.cdn1-371016627628904547-1624271876642360718.png",
            "datastore_url": "https://cdn1.drawpforschool.com/assets/2161/cdn1-2161466891022460039-1623047902534794128/2040x1536/cdn1-2161466891022460039-1623047902534794128.png",
            "th": "https://cdn1.drawpforschool.com/assets/cdn1-6808939429515911552-1624434086191995051/thumbnail.cdn1-6808939429515911552-1624434086191995051.png",
            "canvas_id": "51a7e38637ba83000b001000",
            "textbox": [
              {
                "text": "Can you explain/write the elements of the story on the chart?",
                "left": 0,
                "top": 26.4,
                "width": 960,
                "height": 46.8031496062992,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto",
                "fontSize": 25.33,
                "bold": false,
                "italic": false,
                "color": "#303030"
              },
              {
                "text": "Setting",
                "left": 426.666692913386,
                "top": 85.2,
                "width": 105.322834645669,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#303F9F"
              },
              {
                "text": "Characters",
                "left": 421.333307086614,
                "top": 276,
                "width": 116,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "",
                "left": 60,
                "top": 123.6,
                "width": 838.677165354331,
                "height": 134.393700787402,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 89.3333070866142,
                "top": 309.6,
                "width": 781.322834645669,
                "height": 156,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-7010764452542552270-1489378845865288831/cdn1-7010764452542552270-1489378845865288831.png",
            "name": "Story_5Ws",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-6329717335783477292-1624434359561297797/thumbnail.cdn1-6329717335783477292-1624434359561297797.png",
            "canvas_id": "51a7e35637ba83000a000043",
            "textbox": [
              {
                "text": "",
                "left": 25.92,
                "top": 38.0159842519685,
                "width": 908.157480314961,
                "height": 65.6692913385827,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 25.92,
                "top": 144.287952755906,
                "width": 908.157480314961,
                "height": 65.6692913385827,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 25.92,
                "top": 249.695984251968,
                "width": 908.157480314961,
                "height": 65.6692913385827,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 25.92,
                "top": 352.512047244095,
                "width": 908.157480314961,
                "height": 65.6692913385827,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 25.92,
                "top": 454.464015748031,
                "width": 908.157480314961,
                "height": 65.6692913385827,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "multiple": true,
            "name": "Wonder_Organizers_Charts_05_CauseEffect",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-5487829669153940599-1624271435024843918/thumbnail.cdn1-5487829669153940599-1624271435024843918.png",
            "datastore_url": "https://cdn1.drawpforschool.com/assets/3533/cdn1-3533010280253072312-1623047906246732673/2040x1536/cdn1-3533010280253072312-1623047906246732673.png",
            "th": "https://cdn1.drawpforschool.com/assets/cdn1-9146254869491577795-1624433101588402859/thumbnail.cdn1-9146254869491577795-1624433101588402859.png",
            "premium": true,
            "canvas_id": "51a7e38637ba83000b001004",
            "textbox": [
              {
                "text": "",
                "left": 23.04,
                "top": 38.88,
                "width": 252.472440944882,
                "height": 220.314960629921,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 23.04,
                "top": 301.535984251969,
                "width": 252.472440944882,
                "height": 220.314960629921,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 681.6,
                "top": 38.88,
                "width": 252.472440944882,
                "height": 220.314960629921,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 681.6,
                "top": 301.535984251969,
                "width": 252.472440944882,
                "height": 220.314960629921,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 352.32,
                "top": 189.215984251969,
                "width": 252.472440944882,
                "height": 168.472440944882,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-3442748723416692879-1489378848054344899/cdn1-3442748723416692879-1489378848054344899.png",
            "name": "Story_Mapping",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-2234151656183247804-1624434751212681195/thumbnail.cdn1-2234151656183247804-1624434751212681195.png",
            "canvas_id": "51a7e36837ba830009000543",
            "textbox": [
              {
                "text": "",
                "left": 23.04,
                "top": 38.88,
                "width": 252.472440944882,
                "height": 220.314960629921,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 23.04,
                "top": 301.535984251969,
                "width": 252.472440944882,
                "height": 220.314960629921,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 681.6,
                "top": 38.88,
                "width": 252.472440944882,
                "height": 220.314960629921,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 681.6,
                "top": 301.535984251969,
                "width": 252.472440944882,
                "height": 220.314960629921,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 352.32,
                "top": 189.215984251969,
                "width": 252.472440944882,
                "height": 168.472440944882,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "premium": true,
            "name": "Wonder_Organizers_Charts_06_Summary",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-5919467207007844057-1624272081436178743/thumbnail.cdn1-5919467207007844057-1624272081436178743.png",
            "datastore_url": "https://cdn1.drawpforschool.com/assets/5166/cdn1-516698934074003245-1623047905363582443/2040x1536/cdn1-516698934074003245-1623047905363582443.png",
            "th": "https://cdn1.drawpforschool.com/assets/cdn1-4302744778854195806-1624434880320035476/thumbnail.cdn1-4302744778854195806-1624434880320035476.png",
            "canvas_id": "51a7e38637ba83000b001005",
            "textbox": [
              {
                "text": "Can you explain/write the events of the story on the chart?",
                "left": 85.3333070866142,
                "top": 32.4,
                "width": 789.322834645669,
                "height": 46.8031496062992,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto",
                "fontSize": 25.33,
                "bold": false,
                "italic": false,
                "color": "#303030"
              },
              {
                "text": "Summary",
                "left": 420,
                "top": 404.4,
                "width": 121.322834645669,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#303F9F"
              },
              {
                "text": "Event",
                "left": 120,
                "top": 102,
                "width": 116,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "Event",
                "left": 421.333307086614,
                "top": 102,
                "width": 116,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "Event",
                "left": 714.666692913386,
                "top": 102,
                "width": 116,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "",
                "left": 48,
                "top": 436.8,
                "width": 858.677165354331,
                "height": 66.0157480314961,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 57.3333070866142,
                "top": 138,
                "width": 252,
                "height": 248.409448818898,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 349.333307086614,
                "top": 138,
                "width": 252,
                "height": 248.409448818898,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 642.666692913386,
                "top": 138,
                "width": 252,
                "height": 248.409448818898,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-6153101000750041866-1489378849085158446/cdn1-6153101000750041866-1489378849085158446.png",
            "name": "Story_Novel_Organizer_01",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-5070169539199459739-1624434970350712577/thumbnail.cdn1-5070169539199459739-1624434970350712577.png",
            "canvas_id": "51a7e37b37ba830009006541",
            "textbox": [
              {
                "text": "",
                "left": 21.12,
                "top": 47.52,
                "width": 235.212598425197,
                "height": 240.188976377953,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 282.24,
                "top": 47.52,
                "width": 304.314960629921,
                "height": 240.188976377953,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 617.28,
                "top": 39.7440157480315,
                "width": 317.763779527559,
                "height": 91.5905511811024,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 617.28,
                "top": 173.664015748031,
                "width": 317.763779527559,
                "height": 114.047244094488,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 21.12,
                "top": 330.047952755905,
                "width": 907.212598425197,
                "height": 187.496062992126,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "premium": true,
            "name": "Wonder_Organizers_Charts_07_CompareContrast",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-5505742331109639590-1624272715288825424/thumbnail.cdn1-5505742331109639590-1624272715288825424.png",
            "datastore_url": "https://cdn1.drawpforschool.com/assets/8945/cdn1-8945797129551447567-1623047907160164499/2040x1536/cdn1-8945797129551447567-1623047907160164499.png",
            "th": "https://cdn1.drawpforschool.com/assets/cdn1-7566029965202257643-1624435074616276522/thumbnail.cdn1-7566029965202257643-1624435074616276522.png",
            "canvas_id": "51a7e38637ba83000b001006",
            "textbox": [
              {
                "text": "Can you write details of each character in the story?",
                "left": 109.333307086614,
                "top": 32.4,
                "width": 741.322834645669,
                "height": 46.8031496062992,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto",
                "fontSize": 25.33,
                "bold": false,
                "italic": false,
                "color": "#303030"
              },
              {
                "text": "Character",
                "left": 125.333307086614,
                "top": 86.4,
                "width": 106.677165354331,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#303F9F"
              },
              {
                "text": "Character",
                "left": 426.666692913386,
                "top": 86.4,
                "width": 106.677165354331,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#303F9F"
              },
              {
                "text": "Character",
                "left": 725.333307086614,
                "top": 86.4,
                "width": 106.677165354331,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#303F9F"
              },
              {
                "text": "Detail",
                "left": 121.333307086614,
                "top": 153.6,
                "width": 116,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "Detail",
                "left": 421.333307086614,
                "top": 153.6,
                "width": 116,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "Detail",
                "left": 718.666692913386,
                "top": 153.6,
                "width": 116,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "",
                "left": 53.3333070866142,
                "top": 117.6,
                "width": 252,
                "height": 27.5905511811024,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 354.666692913386,
                "top": 117.6,
                "width": 252,
                "height": 27.5905511811024,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 653.333307086614,
                "top": 117.6,
                "width": 252,
                "height": 27.5905511811024,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 53.3333070866142,
                "top": 190.8,
                "width": 252,
                "height": 298.803149606299,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 354.666692913386,
                "top": 190.8,
                "width": 252,
                "height": 298.803149606299,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 653.333307086614,
                "top": 190.8,
                "width": 252,
                "height": 298.803149606299,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-6489223585452165934-1489378850344198739/cdn1-6489223585452165934-1489378850344198739.png",
            "name": "Story_Novel_Organizer_02",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-3131810550436378283-1624435151881040322/thumbnail.cdn1-3131810550436378283-1624435151881040322.png",
            "canvas_id": "51a7e38637ba83000b000876",
            "textbox": [
              {
                "text": "",
                "left": 24,
                "top": 49.2479527559055,
                "width": 192.944881889764,
                "height": 468.283464566929,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 241.92,
                "top": 49.2479527559055,
                "width": 192.944881889764,
                "height": 468.283464566929,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 478.08,
                "top": 38.0159842519685,
                "width": 459.842519685039,
                "height": 91.5905511811024,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "multiple": true,
            "name": "Wonder_Organizers_Charts_08_Inferences",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-8032986566966368616-1624271517313024812/thumbnail.cdn1-8032986566966368616-1624271517313024812.png",
            "datastore_url": "https://cdn1.drawpforschool.com/assets/9035/cdn1-9035571337414627925-1623047895825027802/2040x1536/cdn1-9035571337414627925-1623047895825027802.png",
            "th": "https://cdn1.drawpforschool.com/assets/cdn1-7357897091275832416-1624433395959778585/thumbnail.cdn1-7357897091275832416-1624433395959778585.png",
            "premium": true,
            "canvas_id": "51a7e38637ba83000b001007",
            "textbox": [
              {
                "text": "",
                "left": 22.6666929133858,
                "top": 48.3840157480315,
                "width": 285.133858267717,
                "height": 473.48031496063,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 337.333307086614,
                "top": 48.3840157480315,
                "width": 285.133858267717,
                "height": 473.48031496063,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 653.333307086614,
                "top": 48.3840157480315,
                "width": 285.133858267717,
                "height": 473.48031496063,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-7551682273871229073-1489378852277537665/cdn1-7551682273871229073-1489378852277537665.png",
            "name": "Story_Table_Conclusions",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-2263939542826209472-1624435249861659219/thumbnail.cdn1-2263939542826209472-1624435249861659219.png",
            "canvas_id": "51a7e38637ba83000b000879",
            "textbox": [
              {
                "text": "",
                "left": 22.6666929133858,
                "top": 48.3840157480315,
                "width": 285.133858267717,
                "height": 473.48031496063,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 337.333307086614,
                "top": 48.3840157480315,
                "width": 285.133858267717,
                "height": 473.48031496063,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 653.333307086614,
                "top": 48.3840157480315,
                "width": 285.133858267717,
                "height": 473.48031496063,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "multiple": true,
            "name": "Wonder_Organizers_Charts_11_CharacterSetting",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-6415857937854634387-1624271718136847333/thumbnail.cdn1-6415857937854634387-1624271718136847333.png",
            "datastore_url": "https://cdn1.drawpforschool.com/assets/1836/cdn1-1836882615449568934-1623047901332389509/2040x1536/cdn1-1836882615449568934-1623047901332389509.png",
            "th": "https://cdn1.drawpforschool.com/assets/cdn1-420566084593299340-1624433959736265176/thumbnail.cdn1-420566084593299340-1624433959736265176.png",
            "premium": true,
            "canvas_id": "51a7e38637ba83000b001099",
            "textbox": []
          },
          {
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-3263956999133380945-1624272997476685090/thumbnail.cdn1-3263956999133380945-1624272997476685090.png",
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-5542958864558530125-1489378853232289066/cdn1-5542958864558530125-1489378853232289066.png",
            "name": "Story_Timeline",
            "th": "https://cdn1.drawpforschool.com/assets/cdn1-3263956999133380945-1624272997476685090/thumbnail.cdn1-3263956999133380945-1624272997476685090.png",
            "canvas_id": "51a7e38637ba83000b000999",
            "textbox": []
          }
        ],
        "id": "7",
        "free": "False"
      },
      {
        "bundle_cover_image_url": "https://s3.amazonaws.com/drawp-school-canvases-new/story/thumbnails/Story_Cover_es.png",
        "scale": 1,
        "image_url": "https://s3.amazonaws.com/drawp-school-canvases-new/story/Story_Cover_es.png",
        "product_id": "STORY_CANVAS_BUNDLE",
        "language": "es",
        "bundle_status": 0,
        "bundle_name": "Story",
        "canvas_list": [
          {
            "premium": true,
            "name": "Wonder_Organizers_Charts_01_Setting",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-8673339415882495506-1624338364270884453/thumbnail.cdn1-8673339415882495506-1624338364270884453.png",
            "datastore_url": "https://cdn1.drawpforschool.com/assets/2161/cdn1-2161466891022460039-1623047902534794128/2040x1536/cdn1-2161466891022460039-1623047902534794128.png",
            "th": "https://cdn1.drawpforschool.com/assets/cdn1-6808939429515911552-1624434086191995051/thumbnail.cdn1-6808939429515911552-1624434086191995051.png",
            "canvas_id": "51a7e38637ba83000b001199",
            "textbox": [
              {
                "text": "¿Puedes describir los siguientes elementos de la narración/cuento en el gráfico?",
                "left": 0,
                "top": 26.4,
                "width": 960,
                "height": 46.8031496062992,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto",
                "fontSize": 25.33,
                "bold": false,
                "italic": false,
                "color": "#303030"
              },
              {
                "text": "Escenario",
                "left": 426.666692913386,
                "top": 85.2,
                "width": 105.322834645669,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#303F9F"
              },
              {
                "text": "Personajes",
                "left": 421.333307086614,
                "top": 276,
                "width": 116,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "",
                "left": 60,
                "top": 123.6,
                "width": 838.677165354331,
                "height": 134.393700787402,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 89.3333070866142,
                "top": 309.6,
                "width": 781.322834645669,
                "height": 156,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-3748968997070931749-1489379026008274914/cdn1-3748968997070931749-1489379026008274914.png",
            "name": "Story_5Ws_es",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-1892422729734240155-1624434409985167044/thumbnail.cdn1-1892422729734240155-1624434409985167044.png",
            "canvas_id": "51a7e35637ba83000a000043",
            "textbox": [
              {
                "text": "",
                "left": 25.92,
                "top": 38.0159842519685,
                "width": 908.157480314961,
                "height": 65.6692913385827,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 25.92,
                "top": 144.287952755906,
                "width": 908.157480314961,
                "height": 65.6692913385827,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 25.92,
                "top": 249.695984251968,
                "width": 908.157480314961,
                "height": 65.6692913385827,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 25.92,
                "top": 352.512047244095,
                "width": 908.157480314961,
                "height": 65.6692913385827,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 25.92,
                "top": 454.464015748031,
                "width": 908.157480314961,
                "height": 65.6692913385827,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "multiple": true,
            "name": "Wonder_Organizers_Charts_05_CauseEffect",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-8212814485509400137-1624338060391280203/thumbnail.cdn1-8212814485509400137-1624338060391280203.png",
            "datastore_url": "https://cdn1.drawpforschool.com/assets/3533/cdn1-3533010280253072312-1623047906246732673/2040x1536/cdn1-3533010280253072312-1623047906246732673.png",
            "th": "https://cdn1.drawpforschool.com/assets/cdn1-9146254869491577795-1624433101588402859/thumbnail.cdn1-9146254869491577795-1624433101588402859.png",
            "premium": true,
            "canvas_id": "51a7e38637ba83000b001599",
            "textbox": [
              {
                "text": "",
                "left": 23.04,
                "top": 38.88,
                "width": 252.472440944882,
                "height": 220.314960629921,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 23.04,
                "top": 301.535984251969,
                "width": 252.472440944882,
                "height": 220.314960629921,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 681.6,
                "top": 38.88,
                "width": 252.472440944882,
                "height": 220.314960629921,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 681.6,
                "top": 301.535984251969,
                "width": 252.472440944882,
                "height": 220.314960629921,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 352.32,
                "top": 189.215984251969,
                "width": 252.472440944882,
                "height": 168.472440944882,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-4028331982618079961-1489379026534099937/cdn1-4028331982618079961-1489379026534099937.png",
            "name": "Story_Mapping_es",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-4220887411230397473-1624434814180534639/thumbnail.cdn1-4220887411230397473-1624434814180534639.png",
            "canvas_id": "51a7e36837ba830009000543",
            "textbox": [
              {
                "text": "",
                "left": 23.04,
                "top": 38.88,
                "width": 252.472440944882,
                "height": 220.314960629921,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 23.04,
                "top": 301.535984251969,
                "width": 252.472440944882,
                "height": 220.314960629921,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 681.6,
                "top": 38.88,
                "width": 252.472440944882,
                "height": 220.314960629921,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 681.6,
                "top": 301.535984251969,
                "width": 252.472440944882,
                "height": 220.314960629921,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 352.32,
                "top": 189.215984251969,
                "width": 252.472440944882,
                "height": 168.472440944882,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "premium": true,
            "name": "Wonder_Organizers_Charts_06_Summary",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-7795615749678195107-1624338611223093829/thumbnail.cdn1-7795615749678195107-1624338611223093829.png",
            "datastore_url": "https://cdn1.drawpforschool.com/assets/5166/cdn1-516698934074003245-1623047905363582443/2040x1536/cdn1-516698934074003245-1623047905363582443.png",
            "th": "https://cdn1.drawpforschool.com/assets/cdn1-4302744778854195806-1624434880320035476/thumbnail.cdn1-4302744778854195806-1624434880320035476.png",
            "canvas_id": "51a7e38637ba83000b001699",
            "textbox": [
              {
                "text": "¿Puedes describir los eventos de la narración/cuento en el gráfico?",
                "left": 85.3333070866142,
                "top": 32.4,
                "width": 789.322834645669,
                "height": 46.8031496062992,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto",
                "fontSize": 25.33,
                "bold": false,
                "italic": false,
                "color": "#303030"
              },
              {
                "text": "Resumen",
                "left": 420,
                "top": 404.4,
                "width": 121.322834645669,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#303F9F"
              },
              {
                "text": "Evento",
                "left": 120,
                "top": 102,
                "width": 116,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "Evento",
                "left": 421.333307086614,
                "top": 102,
                "width": 116,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "Evento",
                "left": 714.666692913386,
                "top": 102,
                "width": 116,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "",
                "left": 48,
                "top": 436.8,
                "width": 858.677165354331,
                "height": 66.0157480314961,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 57.3333070866142,
                "top": 138,
                "width": 252,
                "height": 248.409448818898,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 349.333307086614,
                "top": 138,
                "width": 252,
                "height": 248.409448818898,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 642.666692913386,
                "top": 138,
                "width": 252,
                "height": 248.409448818898,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-5995352615567740939-1489379026391670164/cdn1-5995352615567740939-1489379026391670164.png",
            "name": "Story_Novel_Organizer_01_es",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-7922963283555304967-1624434998262541285/thumbnail.cdn1-7922963283555304967-1624434998262541285.png",
            "canvas_id": "51a7e37b37ba830009006541",
            "textbox": [
              {
                "text": "",
                "left": 21.12,
                "top": 47.52,
                "width": 235.212598425197,
                "height": 240.188976377953,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 282.24,
                "top": 47.52,
                "width": 304.314960629921,
                "height": 240.188976377953,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 617.28,
                "top": 39.7440157480315,
                "width": 317.763779527559,
                "height": 91.5905511811024,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 617.28,
                "top": 173.664015748031,
                "width": 317.763779527559,
                "height": 114.047244094488,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 21.12,
                "top": 330.047952755905,
                "width": 907.212598425197,
                "height": 187.496062992126,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "premium": true,
            "name": "Wonder_Organizers_Charts_07_CompareContrast",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-1644925467272195101-1624338687881298775/thumbnail.cdn1-1644925467272195101-1624338687881298775.png",
            "datastore_url": "https://cdn1.drawpforschool.com/assets/8945/cdn1-8945797129551447567-1623047907160164499/2040x1536/cdn1-8945797129551447567-1623047907160164499.png",
            "th": "https://cdn1.drawpforschool.com/assets/cdn1-7566029965202257643-1624435074616276522/thumbnail.cdn1-7566029965202257643-1624435074616276522.png",
            "canvas_id": "51a7e38637ba83000b001799",
            "textbox": [
              {
                "text": "¿Puedes describir cada personaje de la/el narración/cuento?",
                "left": 109.333307086614,
                "top": 32.4,
                "width": 741.322834645669,
                "height": 46.8031496062992,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto",
                "fontSize": 25.33,
                "bold": false,
                "italic": false,
                "color": "#303030"
              },
              {
                "text": "Personaje",
                "left": 125.333307086614,
                "top": 86.4,
                "width": 106.677165354331,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#303F9F"
              },
              {
                "text": "Personaje",
                "left": 426.666692913386,
                "top": 86.4,
                "width": 106.677165354331,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#303F9F"
              },
              {
                "text": "Personaje",
                "left": 725.333307086614,
                "top": 86.4,
                "width": 106.677165354331,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#303F9F"
              },
              {
                "text": "Detalle",
                "left": 121.333307086614,
                "top": 153.6,
                "width": 116,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "Detalle",
                "left": 421.333307086614,
                "top": 153.6,
                "width": 116,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "Detalle",
                "left": 718.666692913386,
                "top": 153.6,
                "width": 116,
                "height": 38.3937007874016,
                "borderColor": "",
                "borderWidth": -1,
                "borderStyle": "Solid",
                "alignment": "Center",
                "fontName": "Roboto Medium",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#448AFF"
              },
              {
                "text": "",
                "left": 53.3333070866142,
                "top": 117.6,
                "width": 252,
                "height": 27.5905511811024,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 354.666692913386,
                "top": 117.6,
                "width": 252,
                "height": 27.5905511811024,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 653.333307086614,
                "top": 117.6,
                "width": 252,
                "height": 27.5905511811024,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 53.3333070866142,
                "top": 190.8,
                "width": 252,
                "height": 298.803149606299,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 354.666692913386,
                "top": 190.8,
                "width": 252,
                "height": 298.803149606299,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 653.333307086614,
                "top": 190.8,
                "width": 252,
                "height": 298.803149606299,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-4271839233974745284-1489379026396883291/cdn1-4271839233974745284-1489379026396883291.png",
            "name": "Story_Novel_Organizer_02_es",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-4821272384173732547-1624435179019600131/thumbnail.cdn1-4821272384173732547-1624435179019600131.png",
            "canvas_id": "51a7e38637ba83000b000876",
            "textbox": [
              {
                "text": "",
                "left": 24,
                "top": 49.2479527559055,
                "width": 192.944881889764,
                "height": 468.283464566929,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 241.92,
                "top": 49.2479527559055,
                "width": 192.944881889764,
                "height": 468.283464566929,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 478.08,
                "top": 38.0159842519685,
                "width": 459.842519685039,
                "height": 91.5905511811024,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "multiple": true,
            "name": "Wonder_Organizers_Charts_08_Inferences",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-485738521661741253-1624338169446480844/thumbnail.cdn1-485738521661741253-1624338169446480844.png",
            "datastore_url": "https://cdn1.drawpforschool.com/assets/9035/cdn1-9035571337414627925-1623047895825027802/2040x1536/cdn1-9035571337414627925-1623047895825027802.png",
            "th": "https://cdn1.drawpforschool.com/assets/cdn1-7357897091275832416-1624433395959778585/thumbnail.cdn1-7357897091275832416-1624433395959778585.png",
            "premium": true,
            "canvas_id": "51a7e38637ba83000b001899",
            "textbox": [
              {
                "text": "",
                "left": 22.6666929133858,
                "top": 48.3840157480315,
                "width": 285.133858267717,
                "height": 473.48031496063,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 337.333307086614,
                "top": 48.3840157480315,
                "width": 285.133858267717,
                "height": 473.48031496063,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 653.333307086614,
                "top": 48.3840157480315,
                "width": 285.133858267717,
                "height": 473.48031496063,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-7920842658278552601-1489379027184989455/cdn1-7920842658278552601-1489379027184989455.png",
            "name": "Story_Table_Conclusions_es",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-3839783433453064020-1624435311055192257/thumbnail.cdn1-3839783433453064020-1624435311055192257.png",
            "canvas_id": "51a7e38637ba83000b000879",
            "textbox": [
              {
                "text": "",
                "left": 22.6666929133858,
                "top": 48.3840157480315,
                "width": 285.133858267717,
                "height": 473.48031496063,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 337.333307086614,
                "top": 48.3840157480315,
                "width": 285.133858267717,
                "height": 473.48031496063,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 653.333307086614,
                "top": 48.3840157480315,
                "width": 285.133858267717,
                "height": 473.48031496063,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "multiple": true,
            "name": "Wonder_Organizers_Charts_11_CharacterSetting",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-150437370412394460-1624338325981564559/thumbnail.cdn1-150437370412394460-1624338325981564559.png",
            "datastore_url": "https://cdn1.drawpforschool.com/assets/1836/cdn1-1836882615449568934-1623047901332389509/2040x1536/cdn1-1836882615449568934-1623047901332389509.png",
            "th": "https://cdn1.drawpforschool.com/assets/cdn1-420566084593299340-1624433959736265176/thumbnail.cdn1-420566084593299340-1624433959736265176.png",
            "premium": true,
            "canvas_id": "51a7e38637ba83000b001997",
            "textbox": []
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-4289442863949339081-1489378853203470512/cdn1-4289442863949339081-1489378853203470512.png",
            "name": "Story_Timeline",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-3263956999133380945-1624272997476685090/thumbnail.cdn1-3263956999133380945-1624272997476685090.png",
            "canvas_id": "51a7e38637ba83000b000999",
            "textbox": []
          }
        ],
        "id": "7",
        "free": "False"
      },
      {
        "bundle_cover_image_url": "https://s3.amazonaws.com/drawp-school-canvases-new/flow/thumbnails/Flow_Cover.png",
        "scale": 1,
        "image_url": "https://s3.amazonaws.com/drawp-school-canvases-new/flow/Flow_Cover.png",
        "product_id": "FLOW_CANVAS_BUNDLE",
        "language": "en",
        "bundle_status": 0,
        "bundle_name": "Flow",
        "canvas_list": [
          {
            "th": "https://cdn1.drawpforschool.com/assets/cdn1-8295677620040118958-1624273117746615159/thumbnail.cdn1-8295677620040118958-1624273117746615159.png",
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-6199430495602413131-1489378606339821790/cdn1-6199430495602413131-1489378606339821790.png",
            "name": "Flow_Bridging",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-8187744022176466374-1624435393319977016/thumbnail.cdn1-8187744022176466374-1624435393319977016.png",
            "canvas_id": "51a7e35637ba83700a000000",
            "textbox": [
              {
                "text": "",
                "left": 93.12,
                "top": 63.9359842519685,
                "width": 228.472440944882,
                "height": 153.795275590551,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 368.64,
                "top": 63.9359842519685,
                "width": 228.472440944882,
                "height": 153.795275590551,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 643.2,
                "top": 63.9359842519685,
                "width": 228.472440944882,
                "height": 153.795275590551,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 93.12,
                "top": 319.68,
                "width": 228.472440944882,
                "height": 153.795275590551,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 368.64,
                "top": 319.68,
                "width": 228.472440944882,
                "height": 153.795275590551,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 643.2,
                "top": 319.68,
                "width": 228.472440944882,
                "height": 153.795275590551,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "th": "https://cdn1.drawpforschool.com/assets/cdn1-3144700855344241812-1624273197544029127/thumbnail.cdn1-3144700855344241812-1624273197544029127.png",
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-8492362874774136670-1489378608553469983/cdn1-8492362874774136670-1489378608553469983.png",
            "name": "Flow_Cycle_Color",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-166703017657789865-1624435478267173672/thumbnail.cdn1-166703017657789865-1624435478267173672.png",
            "canvas_id": "51a7e36837ba837009000000",
            "textbox": [
              {
                "text": "",
                "left": 321.6,
                "top": 19.8720472440945,
                "width": 335.338582677165,
                "height": 141.606299212598,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 46.08,
                "top": 199.584015748032,
                "width": 335.338582677165,
                "height": 141.606299212598,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 601.92,
                "top": 197.855984251968,
                "width": 335.338582677165,
                "height": 141.606299212598,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 321.6,
                "top": 375.84,
                "width": 335.338582677165,
                "height": 141.606299212598,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "th": "https://cdn1.drawpforschool.com/assets/cdn1-6561582419976676090-1624273344898546561/thumbnail.cdn1-6561582419976676090-1624273344898546561.png",
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-1636484588703578533-1489378610927737274/cdn1-1636484588703578533-1489378610927737274.png",
            "name": "Flow_Flow",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-6918111927172244345-1624435559604375251/thumbnail.cdn1-6918111927172244345-1624435559604375251.png",
            "canvas_id": "51a7e37b37ba830007700001",
            "textbox": [
              {
                "text": "",
                "left": 141.12,
                "top": 10.3679527559055,
                "width": 680,
                "height": 44.0629921259843,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 15.36,
                "top": 82.9440157480315,
                "width": 930.236220472441,
                "height": 54.4251968503937,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 15.36,
                "top": 180.575984251968,
                "width": 930.236220472441,
                "height": 54.4251968503937,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 15.36,
                "top": 277.344015748031,
                "width": 930.236220472441,
                "height": 54.4251968503937,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 15.36,
                "top": 374.112047244094,
                "width": 930.236220472441,
                "height": 54.4251968503937,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 15.36,
                "top": 474.335984251969,
                "width": 930.236220472441,
                "height": 54.4251968503937,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "th": "https://cdn1.drawpforschool.com/assets/cdn1-2235066014569811670-1624273441002890793/thumbnail.cdn1-2235066014569811670-1624273441002890793.png",
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-786963262605155846-1489378614501734144/cdn1-786963262605155846-1489378614501734144.png",
            "name": "Flow_Triangle",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-1067813599580589643-1624435620310691845/thumbnail.cdn1-1067813599580589643-1624435620310691845.png",
            "canvas_id": "51a7e38637ba83007b000000",
            "textbox": [
              {
                "text": "",
                "left": 85.44,
                "top": 20.7359842519685,
                "width": 798.708661417323,
                "height": 54.4251968503937,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 146.88,
                "top": 98.4959842519685,
                "width": 666.708661417323,
                "height": 54.4251968503937,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 211.2,
                "top": 171.935984251969,
                "width": 532.787401574803,
                "height": 54.4251968503937,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 282.24,
                "top": 247.967952755906,
                "width": 394.551181102362,
                "height": 54.4251968503937,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 349.44,
                "top": 324.864015748031,
                "width": 262.07874015748,
                "height": 54.4251968503937,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 411.84,
                "top": 397.44,
                "width": 134.393700787402,
                "height": 54.4251968503937,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          }
        ],
        "id": "3",
        "free": "False"
      },
      {
        "bundle_cover_image_url": "https://s3.amazonaws.com/drawp-school-canvases-new/flow/thumbnails/Flow_Cover_es.png",
        "scale": 1,
        "image_url": "https://s3.amazonaws.com/drawp-school-canvases-new/flow/Flow_Cover_es.png",
        "product_id": "FLOW_CANVAS_BUNDLE",
        "language": "es",
        "bundle_status": 0,
        "bundle_name": "Flow",
        "canvas_list": [
          {
            "th": "https://cdn1.drawpforschool.com/assets/cdn1-8295677620040118958-1624273117746615159/thumbnail.cdn1-8295677620040118958-1624273117746615159.png",
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-446682223441594786-1489378606613881255/cdn1-446682223441594786-1489378606613881255.png",
            "name": "Flow_Bridging",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-8187744022176466374-1624435393319977016/thumbnail.cdn1-8187744022176466374-1624435393319977016.png",
            "canvas_id": "51a7e35637ba83700a000000",
            "textbox": [
              {
                "text": "",
                "left": 93.12,
                "top": 63.9359842519685,
                "width": 228.472440944882,
                "height": 153.795275590551,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 368.64,
                "top": 63.9359842519685,
                "width": 228.472440944882,
                "height": 153.795275590551,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 643.2,
                "top": 63.9359842519685,
                "width": 228.472440944882,
                "height": 153.795275590551,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 93.12,
                "top": 319.68,
                "width": 228.472440944882,
                "height": 153.795275590551,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 368.64,
                "top": 319.68,
                "width": 228.472440944882,
                "height": 153.795275590551,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 643.2,
                "top": 319.68,
                "width": 228.472440944882,
                "height": 153.795275590551,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "th": "https://cdn1.drawpforschool.com/assets/cdn1-3144700855344241812-1624273197544029127/thumbnail.cdn1-3144700855344241812-1624273197544029127.png",
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-9102172086719584350-1489378608253601836/cdn1-9102172086719584350-1489378608253601836.png",
            "name": "Flow_Cycle_Color",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-166703017657789865-1624435478267173672/thumbnail.cdn1-166703017657789865-1624435478267173672.png",
            "canvas_id": "51a7e36837ba837009000000",
            "textbox": [
              {
                "text": "",
                "left": 321.6,
                "top": 19.8720472440945,
                "width": 335.338582677165,
                "height": 141.606299212598,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 46.08,
                "top": 199.584015748032,
                "width": 335.338582677165,
                "height": 141.606299212598,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 601.92,
                "top": 197.855984251968,
                "width": 335.338582677165,
                "height": 141.606299212598,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 321.6,
                "top": 375.84,
                "width": 335.338582677165,
                "height": 141.606299212598,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "th": "https://cdn1.drawpforschool.com/assets/cdn1-6561582419976676090-1624273344898546561/thumbnail.cdn1-6561582419976676090-1624273344898546561.png",
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-4371222910836378491-1489378610894963010/cdn1-4371222910836378491-1489378610894963010.png",
            "name": "Flow_Flow",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-6918111927172244345-1624435559604375251/thumbnail.cdn1-6918111927172244345-1624435559604375251.png",
            "canvas_id": "51a7e37b37ba830007700001",
            "textbox": [
              {
                "text": "",
                "left": 141.12,
                "top": 10.3679527559055,
                "width": 680,
                "height": 44.0629921259843,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 15.36,
                "top": 82.9440157480315,
                "width": 930.236220472441,
                "height": 54.4251968503937,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 15.36,
                "top": 180.575984251968,
                "width": 930.236220472441,
                "height": 54.4251968503937,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 15.36,
                "top": 277.344015748031,
                "width": 930.236220472441,
                "height": 54.4251968503937,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 15.36,
                "top": 374.112047244094,
                "width": 930.236220472441,
                "height": 54.4251968503937,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 15.36,
                "top": 474.335984251969,
                "width": 930.236220472441,
                "height": 54.4251968503937,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "th": "https://cdn1.drawpforschool.com/assets/cdn1-2235066014569811670-1624273441002890793/thumbnail.cdn1-2235066014569811670-1624273441002890793.png",
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-2318355029372746241-1489378614484812784/cdn1-2318355029372746241-1489378614484812784.png",
            "name": "Flow_Triangle",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-1067813599580589643-1624435620310691845/thumbnail.cdn1-1067813599580589643-1624435620310691845.png",
            "canvas_id": "51a7e38637ba83007b000000",
            "textbox": [
              {
                "text": "",
                "left": 85.44,
                "top": 20.7359842519685,
                "width": 798.708661417323,
                "height": 54.4251968503937,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 146.88,
                "top": 98.4959842519685,
                "width": 666.708661417323,
                "height": 54.4251968503937,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 211.2,
                "top": 171.935984251969,
                "width": 532.787401574803,
                "height": 54.4251968503937,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 282.24,
                "top": 247.967952755906,
                "width": 394.551181102362,
                "height": 54.4251968503937,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 349.44,
                "top": 324.864015748031,
                "width": 262.07874015748,
                "height": 54.4251968503937,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 411.84,
                "top": 397.44,
                "width": 134.393700787402,
                "height": 54.4251968503937,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          }
        ],
        "id": "3",
        "free": "False"
      },
      {
        "bundle_cover_image_url": "https://s3.amazonaws.com/drawp-school-canvases-new/maps/thumbnails/Maps_Cover.png",
        "scale": 1,
        "image_url": "https://s3.amazonaws.com/drawp-school-canvases-new/maps/Maps_Cover.png",
        "product_id": "MAPS_CANVAS_BUNDLE",
        "language": "en",
        "bundle_status": 0,
        "bundle_name": "Maps",
        "canvas_list": [
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-3612452289129186588-1489378724802033929/cdn1-3612452289129186588-1489378724802033929.png",
            "name": "Maps_Africa",
            "canvas_id": "51a7e35637ba83550a000000",
            "textbox": []
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-941962040173877770-1489378724775364785/cdn1-941962040173877770-1489378724775364785.png",
            "name": "Maps_Asia",
            "canvas_id": "51a7e36837ba836609000000",
            "textbox": []
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-8459194894312504127-1489378726235728739/cdn1-8459194894312504127-1489378726235728739.png",
            "name": "Maps_Europe",
            "canvas_id": "51a7e37b37ba830779000001",
            "textbox": []
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-97677768284534248-1489378729473221802/cdn1-97677768284534248-1489378729473221802.png",
            "name": "Maps_South_America",
            "canvas_id": "51a7e38637ba83880b000000",
            "textbox": []
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-7259211695263585989-1489378727265607685/cdn1-7259211695263585989-1489378727265607685.png",
            "name": "Maps_US_States",
            "canvas_id": "51a7e38637ba83990b000000",
            "textbox": []
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-6701450579989577274-1489378728577270206/cdn1-6701450579989577274-1489378728577270206.png",
            "name": "Maps_World_Map",
            "canvas_id": "51a7e38637ba83140b000000",
            "textbox": []
          }
        ],
        "id": "5",
        "free": "False"
      },
      {
        "bundle_cover_image_url": "https://s3.amazonaws.com/drawp-school-canvases-new/maps/thumbnails/Maps_Cover_es.png",
        "scale": 1,
        "image_url": "https://s3.amazonaws.com/drawp-school-canvases-new/maps/Maps_Cover_es.png",
        "product_id": "MAPS_CANVAS_BUNDLE",
        "language": "es",
        "bundle_status": 0,
        "bundle_name": "Maps",
        "canvas_list": [
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-6894211372746112278-1489378724363849589/cdn1-6894211372746112278-1489378724363849589.png",
            "name": "Maps_Africa",
            "canvas_id": "51a7e35637ba83550a000000",
            "textbox": []
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-7615970981462464190-1489378724914393388/cdn1-7615970981462464190-1489378724914393388.png",
            "name": "Maps_Asia",
            "canvas_id": "51a7e36837ba836609000000",
            "textbox": []
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-8923472890228864608-1489378729287140866/cdn1-8923472890228864608-1489378729287140866.png",
            "name": "Maps_Europe",
            "canvas_id": "51a7e37b37ba830779000001",
            "textbox": []
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-7336482430561000827-1489378728787200198/cdn1-7336482430561000827-1489378728787200198.png",
            "name": "Maps_South_America",
            "canvas_id": "51a7e38637ba83880b000000",
            "textbox": []
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-275852705358953435-1489378727540987978/cdn1-275852705358953435-1489378727540987978.png",
            "name": "Maps_US_States",
            "canvas_id": "51a7e38637ba83990b000000",
            "textbox": []
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-4575507670111131934-1489378729280937075/cdn1-4575507670111131934-1489378729280937075.png",
            "name": "Maps_World_Map",
            "canvas_id": "51a7e38637ba83140b000000",
            "textbox": []
          }
        ],
        "id": "5",
        "free": "False"
      },
      {
        "bundle_cover_image_url": "https://s3.amazonaws.com/drawp-school-canvases-new/tables/thumbnails/Tables_Cover.png",
        "scale": 1,
        "image_url": "https://s3.amazonaws.com/drawp-school-canvases-new/tables/Tables_Cover.png",
        "product_id": "TABLES_CANVAS_BUNDLE",
        "language": "en",
        "bundle_status": 0,
        "bundle_name": "Tables",
        "canvas_list": [
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-7623236522346248204-1489379028455417772/cdn1-7623236522346248204-1489379028455417772.png",
            "name": "Tables_4Column",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-4980541461608389044-1624436034806740816/thumbnail.cdn1-4980541461608389044-1624436034806740816.png",
            "canvas_id": "51a7e35637ba83000a000777",
            "textbox": [
              {
                "text": "",
                "left": 100.8,
                "top": 12.0959842519685,
                "width": 839.055118110236,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 12.48,
                "top": 56.16,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 12.48,
                "top": 100.224015748031,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 12.48,
                "top": 144.287952755906,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 12.48,
                "top": 185.76,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 12.48,
                "top": 229.824015748031,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 12.48,
                "top": 273.887952755906,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 12.48,
                "top": 319.68,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 12.48,
                "top": 361.152047244094,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 12.48,
                "top": 405.215984251969,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 12.48,
                "top": 449.28,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 12.48,
                "top": 493.344015748031,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 250.56,
                "top": 56.16,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 250.56,
                "top": 100.224015748031,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 250.56,
                "top": 144.287952755906,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 250.56,
                "top": 185.76,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 250.56,
                "top": 229.824015748031,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 250.56,
                "top": 273.887952755906,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 250.56,
                "top": 319.68,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 250.56,
                "top": 361.152047244094,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 250.56,
                "top": 405.215984251969,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 250.56,
                "top": 449.28,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 250.56,
                "top": 493.344015748031,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 488.64,
                "top": 56.16,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 488.64,
                "top": 100.224015748031,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 488.64,
                "top": 144.287952755906,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 488.64,
                "top": 185.76,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 488.64,
                "top": 229.824015748031,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 488.64,
                "top": 273.887952755906,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 488.64,
                "top": 319.68,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 488.64,
                "top": 361.152047244094,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 488.64,
                "top": 405.215984251969,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 488.64,
                "top": 449.28,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 488.64,
                "top": 493.344015748031,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 721.92,
                "top": 56.16,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 721.92,
                "top": 100.224015748031,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 721.92,
                "top": 144.287952755906,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 721.92,
                "top": 185.76,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 721.92,
                "top": 229.824015748031,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 721.92,
                "top": 273.887952755906,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 721.92,
                "top": 319.68,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 721.92,
                "top": 361.152047244094,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 721.92,
                "top": 405.215984251969,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 721.92,
                "top": 449.28,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 721.92,
                "top": 493.344015748031,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-221698257293021112-1489379028507016040/cdn1-221698257293021112-1489379028507016040.png",
            "name": "Tables_6Table",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-9211538498022870348-1624436128000010620/thumbnail.cdn1-9211538498022870348-1624436128000010620.png",
            "canvas_id": "51a7e36837ba830009000888",
            "textbox": [
              {
                "text": "",
                "left": 15.36,
                "top": 13.8240157480315,
                "width": 289.92125984252,
                "height": 251.433070866142,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 15.36,
                "top": 276.48,
                "width": 289.92125984252,
                "height": 251.433070866142,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 321.6,
                "top": 13.8240157480315,
                "width": 315.842519685039,
                "height": 251.433070866142,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 321.6,
                "top": 276.48,
                "width": 315.842519685039,
                "height": 251.433070866142,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 653.76,
                "top": 13.8240157480315,
                "width": 289.92125984252,
                "height": 251.433070866142,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 653.76,
                "top": 276.48,
                "width": 289.92125984252,
                "height": 251.433070866142,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-1175775006432410388-1489379028881009011/cdn1-1175775006432410388-1489379028881009011.png",
            "name": "Tables_Cross",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-4383539931771325884-1624436337561763462/thumbnail.cdn1-4383539931771325884-1624436337561763462.png",
            "canvas_id": "51a7e37b37ba830009000999",
            "textbox": [
              {
                "text": "",
                "left": 15.36,
                "top": 13.8240157480315,
                "width": 456,
                "height": 251.433070866142,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 15.36,
                "top": 276.48,
                "width": 456,
                "height": 251.433070866142,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 488.64,
                "top": 13.8240157480315,
                "width": 456,
                "height": 251.433070866142,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 488.64,
                "top": 276.48,
                "width": 456,
                "height": 251.433070866142,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-4070194514907820557-1489379029990974640/cdn1-4070194514907820557-1489379029990974640.png",
            "name": "Tables_Empty",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-5822694271693919569-1624436206366590485/thumbnail.cdn1-5822694271693919569-1624436206366590485.png",
            "canvas_id": "51a7e38637ba83000b001010",
            "textbox": [
              {
                "text": "",
                "left": 22.08,
                "top": 12.0959842519685,
                "width": 917.763779527559,
                "height": 40.5984251968504,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 22.08,
                "top": 97.6320472440945,
                "width": 287.055118110236,
                "height": 425.952755905512,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 337.92,
                "top": 97.6320472440945,
                "width": 287.055118110236,
                "height": 425.952755905512,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 653.76,
                "top": 97.6320472440945,
                "width": 287.055118110236,
                "height": 425.952755905512,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-3492809846006933886-1489379030492692724/cdn1-3492809846006933886-1489379030492692724.png",
            "name": "Tables_Matrix",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-4971178534943973107-1624436452265027045/thumbnail.cdn1-4971178534943973107-1624436452265027045.png",
            "canvas_id": "51a7e38637ba83000b001011",
            "textbox": [
              {
                "text": "",
                "left": 11.52,
                "top": 13.8240157480315,
                "width": 226.551181102362,
                "height": 39.748031496063,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 249.6,
                "top": 13.8240157480315,
                "width": 226.551181102362,
                "height": 39.748031496063,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 483.84,
                "top": 13.8240157480315,
                "width": 226.551181102362,
                "height": 39.748031496063,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 719.04,
                "top": 13.8240157480315,
                "width": 226.551181102362,
                "height": 39.748031496063,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 11.52,
                "top": 62.2079527559055,
                "width": 226.551181102362,
                "height": 86.3937007874016,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 249.6,
                "top": 62.2079527559055,
                "width": 226.551181102362,
                "height": 86.3937007874016,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 483.84,
                "top": 62.2079527559055,
                "width": 226.551181102362,
                "height": 86.3937007874016,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 719.04,
                "top": 62.2079527559055,
                "width": 226.551181102362,
                "height": 86.3937007874016,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 11.52,
                "top": 158.112047244094,
                "width": 226.551181102362,
                "height": 86.3937007874016,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 249.6,
                "top": 158.112047244094,
                "width": 226.551181102362,
                "height": 86.3937007874016,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 483.84,
                "top": 158.112047244094,
                "width": 226.551181102362,
                "height": 86.3937007874016,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 719.04,
                "top": 158.112047244094,
                "width": 226.551181102362,
                "height": 86.3937007874016,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 11.52,
                "top": 258.335984251969,
                "width": 226.551181102362,
                "height": 86.3937007874016,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 249.6,
                "top": 258.335984251969,
                "width": 226.551181102362,
                "height": 86.3937007874016,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 483.84,
                "top": 258.335984251969,
                "width": 226.551181102362,
                "height": 86.3937007874016,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 719.04,
                "top": 258.335984251969,
                "width": 226.551181102362,
                "height": 86.3937007874016,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 11.52,
                "top": 354.24,
                "width": 226.551181102362,
                "height": 86.3937007874016,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 249.6,
                "top": 354.24,
                "width": 226.551181102362,
                "height": 86.3937007874016,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 483.84,
                "top": 354.24,
                "width": 226.551181102362,
                "height": 86.3937007874016,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 719.04,
                "top": 354.24,
                "width": 226.551181102362,
                "height": 86.3937007874016,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 11.52,
                "top": 449.28,
                "width": 226.551181102362,
                "height": 80.3464566929134,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 249.6,
                "top": 449.28,
                "width": 226.551181102362,
                "height": 80.3464566929134,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 483.84,
                "top": 449.28,
                "width": 226.551181102362,
                "height": 80.3464566929134,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 719.04,
                "top": 449.28,
                "width": 226.551181102362,
                "height": 80.3464566929134,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-1878244308293021964-1489379066563416880/cdn1-1878244308293021964-1489379066563416880.png",
            "name": "Tables_Sense",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-4942149520494776896-1624436498453896492/thumbnail.cdn1-4942149520494776896-1624436498453896492.png",
            "canvas_id": "51a7e38637ba83000b001012",
            "textbox": [
              {
                "text": "",
                "left": 12.48,
                "top": 44.9279527559055,
                "width": 170.866141732283,
                "height": 479.527559055118,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 203.52,
                "top": 44.9279527559055,
                "width": 170.866141732283,
                "height": 479.527559055118,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 393.6,
                "top": 44.9279527559055,
                "width": 170.866141732283,
                "height": 479.527559055118,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 584.64,
                "top": 44.9279527559055,
                "width": 170.866141732283,
                "height": 479.527559055118,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 775.68,
                "top": 44.9279527559055,
                "width": 170.866141732283,
                "height": 479.527559055118,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-2709101148504779557-1489379060033440934/cdn1-2709101148504779557-1489379060033440934.png",
            "name": "Tables_Tchart",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-2783286081615559331-1624436546674679384/thumbnail.cdn1-2783286081615559331-1624436546674679384.png",
            "canvas_id": "51a7e38637ba83000b001013",
            "textbox": [
              {
                "text": "",
                "left": 16.32,
                "top": 12.96,
                "width": 453.133858267717,
                "height": 30.2362204724409,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 490.56,
                "top": 12.96,
                "width": 453.133858267717,
                "height": 30.2362204724409,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 16.32,
                "top": 60.48,
                "width": 453.133858267717,
                "height": 463.968503937008,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 490.56,
                "top": 60.48,
                "width": 453.133858267717,
                "height": 463.968503937008,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-4343590347938122115-1489379124038879333/cdn1-4343590347938122115-1489379124038879333.png",
            "name": "Tables_TicTack",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-4137830049566120131-1624436584937252746/thumbnail.cdn1-4137830049566120131-1624436584937252746.png",
            "canvas_id": "51a7e38637ba83000b001015",
            "textbox": [
              {
                "text": "",
                "left": 15.36,
                "top": 13.8240157480315,
                "width": 289.92125984252,
                "height": 152.913385826772,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 321.6,
                "top": 13.8240157480315,
                "width": 315.842519685039,
                "height": 152.913385826772,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 651.84,
                "top": 13.8240157480315,
                "width": 289.92125984252,
                "height": 152.913385826772,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 15.36,
                "top": 184.895984251969,
                "width": 289.92125984252,
                "height": 172.787401574803,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 321.6,
                "top": 184.895984251969,
                "width": 315.842519685039,
                "height": 172.787401574803,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 651.84,
                "top": 184.895984251969,
                "width": 289.92125984252,
                "height": 172.787401574803,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 15.36,
                "top": 370.655984251969,
                "width": 289.92125984252,
                "height": 152.913385826772,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 321.6,
                "top": 370.655984251969,
                "width": 315.842519685039,
                "height": 152.913385826772,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 651.84,
                "top": 370.655984251969,
                "width": 289.92125984252,
                "height": 152.913385826772,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          }
        ],
        "id": "9",
        "free": "False"
      },
      {
        "bundle_cover_image_url": "https://s3.amazonaws.com/drawp-school-canvases-new/tables/thumbnails/Tables_Cover_es.png",
        "scale": 1,
        "image_url": "https://s3.amazonaws.com/drawp-school-canvases-new/tables/Tables_Cover_es.png",
        "product_id": "TABLES_CANVAS_BUNDLE",
        "language": "es",
        "bundle_status": 0,
        "bundle_name": "Tables",
        "canvas_list": [
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-5007983633304815216-1489379170851165207/cdn1-5007983633304815216-1489379170851165207.png",
            "name": "Tables_4Column_es",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-5430007780122678683-1624436074337792203/thumbnail.cdn1-5430007780122678683-1624436074337792203.png",
            "canvas_id": "51a7e35637ba83000a000777",
            "textbox": [
              {
                "text": "",
                "left": 100.8,
                "top": 12.0959842519685,
                "width": 839.055118110236,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 12.48,
                "top": 56.16,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 12.48,
                "top": 100.224015748031,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 12.48,
                "top": 144.287952755906,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 12.48,
                "top": 185.76,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 12.48,
                "top": 229.824015748031,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 12.48,
                "top": 273.887952755906,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 12.48,
                "top": 319.68,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 12.48,
                "top": 361.152047244094,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 12.48,
                "top": 405.215984251969,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 12.48,
                "top": 449.28,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 12.48,
                "top": 493.344015748031,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 250.56,
                "top": 56.16,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 250.56,
                "top": 100.224015748031,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 250.56,
                "top": 144.287952755906,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 250.56,
                "top": 185.76,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 250.56,
                "top": 229.824015748031,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 250.56,
                "top": 273.887952755906,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 250.56,
                "top": 319.68,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 250.56,
                "top": 361.152047244094,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 250.56,
                "top": 405.215984251969,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 250.56,
                "top": 449.28,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 250.56,
                "top": 493.344015748031,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 488.64,
                "top": 56.16,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 488.64,
                "top": 100.224015748031,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 488.64,
                "top": 144.287952755906,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 488.64,
                "top": 185.76,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 488.64,
                "top": 229.824015748031,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 488.64,
                "top": 273.887952755906,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 488.64,
                "top": 319.68,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 488.64,
                "top": 361.152047244094,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 488.64,
                "top": 405.215984251969,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 488.64,
                "top": 449.28,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 488.64,
                "top": 493.344015748031,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 721.92,
                "top": 56.16,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 721.92,
                "top": 100.224015748031,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 721.92,
                "top": 144.287952755906,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 721.92,
                "top": 185.76,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 721.92,
                "top": 229.824015748031,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 721.92,
                "top": 273.887952755906,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 721.92,
                "top": 319.68,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 721.92,
                "top": 361.152047244094,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 721.92,
                "top": 405.215984251969,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 721.92,
                "top": 449.28,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 721.92,
                "top": 493.344015748031,
                "width": 224.629921259843,
                "height": 33.7007874015748,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-1291961969732176548-1489379028720265353/cdn1-1291961969732176548-1489379028720265353.png",
            "name": "Tables_6Table",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-9211538498022870348-1624436128000010620/thumbnail.cdn1-9211538498022870348-1624436128000010620.png",
            "canvas_id": "51a7e36837ba830009000888",
            "textbox": [
              {
                "text": "",
                "left": 15.36,
                "top": 13.8240157480315,
                "width": 289.92125984252,
                "height": 251.433070866142,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 15.36,
                "top": 276.48,
                "width": 289.92125984252,
                "height": 251.433070866142,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 321.6,
                "top": 13.8240157480315,
                "width": 315.842519685039,
                "height": 251.433070866142,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 321.6,
                "top": 276.48,
                "width": 315.842519685039,
                "height": 251.433070866142,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 653.76,
                "top": 13.8240157480315,
                "width": 289.92125984252,
                "height": 251.433070866142,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 653.76,
                "top": 276.48,
                "width": 289.92125984252,
                "height": 251.433070866142,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-6819195404239012119-1489379028781447238/cdn1-6819195404239012119-1489379028781447238.png",
            "name": "Tables_Cross",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-4383539931771325884-1624436337561763462/thumbnail.cdn1-4383539931771325884-1624436337561763462.png",
            "canvas_id": "51a7e37b37ba830009000999",
            "textbox": [
              {
                "text": "",
                "left": 15.36,
                "top": 13.8240157480315,
                "width": 456,
                "height": 251.433070866142,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 15.36,
                "top": 276.48,
                "width": 456,
                "height": 251.433070866142,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 488.64,
                "top": 13.8240157480315,
                "width": 456,
                "height": 251.433070866142,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 488.64,
                "top": 276.48,
                "width": 456,
                "height": 251.433070866142,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-365969598068501743-1489379030014179906/cdn1-365969598068501743-1489379030014179906.png",
            "name": "Tables_Empty",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-5822694271693919569-1624436206366590485/thumbnail.cdn1-5822694271693919569-1624436206366590485.png",
            "canvas_id": "51a7e38637ba83000b001010",
            "textbox": [
              {
                "text": "",
                "left": 22.08,
                "top": 12.0959842519685,
                "width": 917.763779527559,
                "height": 40.5984251968504,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 22.08,
                "top": 97.6320472440945,
                "width": 287.055118110236,
                "height": 425.952755905512,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 337.92,
                "top": 97.6320472440945,
                "width": 287.055118110236,
                "height": 425.952755905512,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 653.76,
                "top": 97.6320472440945,
                "width": 287.055118110236,
                "height": 425.952755905512,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-1590623004515883138-1489379030096912245/cdn1-1590623004515883138-1489379030096912245.png",
            "name": "Tables_Matrix",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-4971178534943973107-1624436452265027045/thumbnail.cdn1-4971178534943973107-1624436452265027045.png",
            "canvas_id": "51a7e38637ba83000b001011",
            "textbox": [
              {
                "text": "",
                "left": 11.52,
                "top": 13.8240157480315,
                "width": 226.551181102362,
                "height": 39.748031496063,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 249.6,
                "top": 13.8240157480315,
                "width": 226.551181102362,
                "height": 39.748031496063,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 483.84,
                "top": 13.8240157480315,
                "width": 226.551181102362,
                "height": 39.748031496063,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 719.04,
                "top": 13.8240157480315,
                "width": 226.551181102362,
                "height": 39.748031496063,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 11.52,
                "top": 62.2079527559055,
                "width": 226.551181102362,
                "height": 86.3937007874016,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 249.6,
                "top": 62.2079527559055,
                "width": 226.551181102362,
                "height": 86.3937007874016,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 483.84,
                "top": 62.2079527559055,
                "width": 226.551181102362,
                "height": 86.3937007874016,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 719.04,
                "top": 62.2079527559055,
                "width": 226.551181102362,
                "height": 86.3937007874016,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 11.52,
                "top": 158.112047244094,
                "width": 226.551181102362,
                "height": 86.3937007874016,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 249.6,
                "top": 158.112047244094,
                "width": 226.551181102362,
                "height": 86.3937007874016,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 483.84,
                "top": 158.112047244094,
                "width": 226.551181102362,
                "height": 86.3937007874016,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 719.04,
                "top": 158.112047244094,
                "width": 226.551181102362,
                "height": 86.3937007874016,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 11.52,
                "top": 258.335984251969,
                "width": 226.551181102362,
                "height": 86.3937007874016,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 249.6,
                "top": 258.335984251969,
                "width": 226.551181102362,
                "height": 86.3937007874016,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 483.84,
                "top": 258.335984251969,
                "width": 226.551181102362,
                "height": 86.3937007874016,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 719.04,
                "top": 258.335984251969,
                "width": 226.551181102362,
                "height": 86.3937007874016,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 11.52,
                "top": 354.24,
                "width": 226.551181102362,
                "height": 86.3937007874016,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 249.6,
                "top": 354.24,
                "width": 226.551181102362,
                "height": 86.3937007874016,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 483.84,
                "top": 354.24,
                "width": 226.551181102362,
                "height": 86.3937007874016,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 719.04,
                "top": 354.24,
                "width": 226.551181102362,
                "height": 86.3937007874016,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 11.52,
                "top": 449.28,
                "width": 226.551181102362,
                "height": 80.3464566929134,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 249.6,
                "top": 449.28,
                "width": 226.551181102362,
                "height": 80.3464566929134,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 483.84,
                "top": 449.28,
                "width": 226.551181102362,
                "height": 80.3464566929134,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 719.04,
                "top": 449.28,
                "width": 226.551181102362,
                "height": 80.3464566929134,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-1079180923491600843-1489379066585896607/cdn1-1079180923491600843-1489379066585896607.png",
            "name": "Tables_Sense",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-4942149520494776896-1624436498453896492/thumbnail.cdn1-4942149520494776896-1624436498453896492.png",
            "canvas_id": "51a7e38637ba83000b001012",
            "textbox": [
              {
                "text": "",
                "left": 12.48,
                "top": 44.9279527559055,
                "width": 170.866141732283,
                "height": 479.527559055118,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 203.52,
                "top": 44.9279527559055,
                "width": 170.866141732283,
                "height": 479.527559055118,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 393.6,
                "top": 44.9279527559055,
                "width": 170.866141732283,
                "height": 479.527559055118,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 584.64,
                "top": 44.9279527559055,
                "width": 170.866141732283,
                "height": 479.527559055118,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 775.68,
                "top": 44.9279527559055,
                "width": 170.866141732283,
                "height": 479.527559055118,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-5348550626492688085-1489379060113863749/cdn1-5348550626492688085-1489379060113863749.png",
            "name": "Tables_Tchart",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-2783286081615559331-1624436546674679384/thumbnail.cdn1-2783286081615559331-1624436546674679384.png",
            "canvas_id": "51a7e38637ba83000b001013",
            "textbox": [
              {
                "text": "",
                "left": 16.32,
                "top": 12.96,
                "width": 453.133858267717,
                "height": 30.2362204724409,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 490.56,
                "top": 12.96,
                "width": 453.133858267717,
                "height": 30.2362204724409,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 16.32,
                "top": 60.48,
                "width": 453.133858267717,
                "height": 463.968503937008,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 490.56,
                "top": 60.48,
                "width": 453.133858267717,
                "height": 463.968503937008,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-6540779597486250415-1489379124065200449/cdn1-6540779597486250415-1489379124065200449.png",
            "name": "Tables_TicTack",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-4137830049566120131-1624436584937252746/thumbnail.cdn1-4137830049566120131-1624436584937252746.png",
            "canvas_id": "51a7e38637ba83000b001015",
            "textbox": [
              {
                "text": "",
                "left": 15.36,
                "top": 13.8240157480315,
                "width": 289.92125984252,
                "height": 152.913385826772,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 321.6,
                "top": 13.8240157480315,
                "width": 315.842519685039,
                "height": 152.913385826772,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 651.84,
                "top": 13.8240157480315,
                "width": 289.92125984252,
                "height": 152.913385826772,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 15.36,
                "top": 184.895984251969,
                "width": 289.92125984252,
                "height": 172.787401574803,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 321.6,
                "top": 184.895984251969,
                "width": 315.842519685039,
                "height": 172.787401574803,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 651.84,
                "top": 184.895984251969,
                "width": 289.92125984252,
                "height": 172.787401574803,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 15.36,
                "top": 370.655984251969,
                "width": 289.92125984252,
                "height": 152.913385826772,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 321.6,
                "top": 370.655984251969,
                "width": 315.842519685039,
                "height": 152.913385826772,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 651.84,
                "top": 370.655984251969,
                "width": 289.92125984252,
                "height": 152.913385826772,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          }
        ],
        "id": "9",
        "free": "False"
      },
      {
        "bundle_cover_image_url": "https://s3.amazonaws.com/drawp-school-canvases-new/time/thumbnails/Time_Cover.png",
        "scale": 1,
        "image_url": "https://s3.amazonaws.com/drawp-school-canvases-new/time/Time_Cover.png",
        "product_id": "TIME_CANVAS_BUNDLE",
        "language": "en",
        "bundle_status": 0,
        "bundle_name": "Time",
        "canvas_list": [
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-6693561012526938323-1489379181761503058/cdn1-6693561012526938323-1489379181761503058.png",
            "name": "Time_Clock_Color",
            "canvas_id": "51a7e35637ba83000a001027",
            "textbox": []
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-6321716581531553877-1489379193216111772/cdn1-6321716581531553877-1489379193216111772.png",
            "name": "Time_Clock",
            "canvas_id": "51a7e36837ba830009001028",
            "textbox": []
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-3866175308507076256-1489379206408513780/cdn1-3866175308507076256-1489379206408513780.png",
            "name": "Time_Time",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-5787124541914805166-1624436702469647861/thumbnail.cdn1-5787124541914805166-1624436702469647861.png",
            "canvas_id": "51a7e37b37ba830009001029",
            "textbox": [
              {
                "text": "",
                "left": 269.76,
                "top": 38.0159842519685,
                "width": 421.448818897638,
                "height": 108.850393700787,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 269.76,
                "top": 211.68,
                "width": 421.448818897638,
                "height": 108.850393700787,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 269.76,
                "top": 391.392047244094,
                "width": 421.448818897638,
                "height": 108.850393700787,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 757.44,
                "top": 83.8079527559055,
                "width": 54.7086614173228,
                "height": 40.5984251968504,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 844.8,
                "top": 83.8079527559055,
                "width": 54.7086614173228,
                "height": 40.5984251968504,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 757.44,
                "top": 260.064015748032,
                "width": 54.7086614173228,
                "height": 40.5984251968504,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 844.8,
                "top": 260.064015748032,
                "width": 54.7086614173228,
                "height": 40.5984251968504,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 757.44,
                "top": 437.184015748031,
                "width": 54.7086614173228,
                "height": 40.5984251968504,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 844.8,
                "top": 437.184015748031,
                "width": 54.7086614173228,
                "height": 40.5984251968504,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          }
        ],
        "id": "11",
        "free": "False"
      },
      {
        "bundle_cover_image_url": "https://s3.amazonaws.com/drawp-school-canvases-new/time/thumbnails/Time_Cover_es.png",
        "scale": 1,
        "image_url": "https://s3.amazonaws.com/drawp-school-canvases-new/time/Time_Cover_es.png",
        "product_id": "TIME_CANVAS_BUNDLE",
        "language": "es",
        "bundle_status": 0,
        "bundle_name": "Time",
        "canvas_list": [
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-1830682842120417372-1489379181725633099/cdn1-1830682842120417372-1489379181725633099.png",
            "name": "Time_Clock_Color",
            "canvas_id": "51a7e35637ba83000a001027",
            "textbox": []
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-227319010645428628-1489379193192113601/cdn1-227319010645428628-1489379193192113601.png",
            "name": "Time_Clock",
            "canvas_id": "51a7e36837ba830009001028",
            "textbox": []
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-6635678045585816592-1489379253717394915/cdn1-6635678045585816592-1489379253717394915.png",
            "name": "Time_Time_es",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-4581746090560612483-1624436733192879284/thumbnail.cdn1-4581746090560612483-1624436733192879284.png",
            "canvas_id": "51a7e37b37ba830009001029",
            "textbox": [
              {
                "text": "",
                "left": 269.76,
                "top": 38.0159842519685,
                "width": 421.448818897638,
                "height": 108.850393700787,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 269.76,
                "top": 211.68,
                "width": 421.448818897638,
                "height": 108.850393700787,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 269.76,
                "top": 391.392047244094,
                "width": 421.448818897638,
                "height": 108.850393700787,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 757.44,
                "top": 83.8079527559055,
                "width": 54.7086614173228,
                "height": 40.5984251968504,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 844.8,
                "top": 83.8079527559055,
                "width": 54.7086614173228,
                "height": 40.5984251968504,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 757.44,
                "top": 260.064015748032,
                "width": 54.7086614173228,
                "height": 40.5984251968504,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 844.8,
                "top": 260.064015748032,
                "width": 54.7086614173228,
                "height": 40.5984251968504,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 757.44,
                "top": 437.184015748031,
                "width": 54.7086614173228,
                "height": 40.5984251968504,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 844.8,
                "top": 437.184015748031,
                "width": 54.7086614173228,
                "height": 40.5984251968504,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          }
        ],
        "id": "11",
        "free": "False"
      },
      {
        "bundle_cover_image_url": "https://s3.amazonaws.com/drawp-school-canvases-new/wheels/thumbnails/Wheel_Cover.png",
        "scale": 1,
        "image_url": "https://s3.amazonaws.com/drawp-school-canvases-new/wheels/Wheel_Cover.png",
        "product_id": "WHEELS_CANVAS_BUNDLE",
        "language": "en",
        "bundle_status": 0,
        "bundle_name": "Wheels",
        "canvas_list": [
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-767647739132406132-1489379260319750065/cdn1-767647739132406132-1489379260319750065.png",
            "name": "Wheel_Cluster",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-2899587953188433688-1624436826374138803/thumbnail.cdn1-2899587953188433688-1624436826374138803.png",
            "canvas_id": "51a7e35637ba83000a001030",
            "textbox": [
              {
                "text": "",
                "left": 48,
                "top": 30.24,
                "width": 118.07874015748,
                "height": 47.5275590551181,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 267.84,
                "top": 30.24,
                "width": 118.07874015748,
                "height": 47.5275590551181,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 574.08,
                "top": 30.24,
                "width": 118.07874015748,
                "height": 47.5275590551181,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 793.92,
                "top": 30.24,
                "width": 118.07874015748,
                "height": 47.5275590551181,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 127.68,
                "top": 119.232047244094,
                "width": 176.629921259843,
                "height": 69.1338582677165,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 658.56,
                "top": 119.232047244094,
                "width": 176.629921259843,
                "height": 69.1338582677165,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 330.24,
                "top": 235.872047244094,
                "width": 298.551181102362,
                "height": 69.1338582677165,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 127.68,
                "top": 351.647952755906,
                "width": 176.629921259843,
                "height": 69.1338582677165,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 658.56,
                "top": 351.647952755906,
                "width": 176.629921259843,
                "height": 69.1338582677165,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 48,
                "top": 462.24,
                "width": 118.07874015748,
                "height": 47.5275590551181,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 267.84,
                "top": 462.24,
                "width": 118.07874015748,
                "height": 47.5275590551181,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 574.08,
                "top": 462.24,
                "width": 118.07874015748,
                "height": 47.5275590551181,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 793.92,
                "top": 462.24,
                "width": 118.07874015748,
                "height": 47.5275590551181,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-6581124715511389993-1489379261513500419/cdn1-6581124715511389993-1489379261513500419.png",
            "name": "Wheel_Goal_Reason",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-6567068827102231682-1624436882286097287/thumbnail.cdn1-6567068827102231682-1624436882286097287.png",
            "canvas_id": "51a7e36837ba830009001031",
            "textbox": [
              {
                "text": "",
                "left": 368.64,
                "top": 60.48,
                "width": 222.708661417323,
                "height": 110.582677165354,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 125.76,
                "top": 228.96,
                "width": 222.708661417323,
                "height": 110.582677165354,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 610.56,
                "top": 228.96,
                "width": 222.708661417323,
                "height": 110.582677165354,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 32.64,
                "top": 425.952047244095,
                "width": 148.787401574803,
                "height": 82.9291338582677,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 296.64,
                "top": 425.952047244095,
                "width": 148.787401574803,
                "height": 82.9291338582677,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 516.48,
                "top": 425.952047244095,
                "width": 148.787401574803,
                "height": 82.9291338582677,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 779.52,
                "top": 425.952047244095,
                "width": 148.787401574803,
                "height": 82.9291338582677,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-604797437491932742-1489379265215216126/cdn1-604797437491932742-1489379265215216126.png",
            "name": "Wheel_Idea",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-3393971523427801160-1624436968400083135/thumbnail.cdn1-3393971523427801160-1624436968400083135.png",
            "canvas_id": "51a7e37b37ba830009001032",
            "textbox": [
              {
                "text": "",
                "left": 208.32,
                "top": 108.864015748031,
                "width": 263.055118110236,
                "height": 154.645669291339,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 487.68,
                "top": 108.864015748031,
                "width": 263.055118110236,
                "height": 154.645669291339,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 208.32,
                "top": 273.887952755906,
                "width": 263.055118110236,
                "height": 154.645669291339,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 487.68,
                "top": 273.887952755906,
                "width": 263.055118110236,
                "height": 154.645669291339,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-104894688160810667-1489379268146549222/cdn1-104894688160810667-1489379268146549222.png",
            "name": "Wheel_MAp",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-253131366265868552-1624437110604298003/thumbnail.cdn1-253131366265868552-1624437110604298003.png",
            "canvas_id": "51a7e36837ba830009001033",
            "textbox": [
              {
                "text": "",
                "left": 78.72,
                "top": 138.24,
                "width": 231.370078740157,
                "height": 79.496062992126,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 78.72,
                "top": 301.535984251969,
                "width": 231.370078740157,
                "height": 79.496062992126,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 364.8,
                "top": 50.9759842519685,
                "width": 263.055118110236,
                "height": 79.496062992126,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 364.8,
                "top": 222.912047244094,
                "width": 263.055118110236,
                "height": 79.496062992126,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 364.8,
                "top": 406.08,
                "width": 263.055118110236,
                "height": 79.496062992126,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 655.68,
                "top": 138.24,
                "width": 231.370078740157,
                "height": 79.496062992126,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 655.68,
                "top": 301.535984251969,
                "width": 231.370078740157,
                "height": 79.496062992126,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-8013247408656553297-1489379269905597160/cdn1-8013247408656553297-1489379269905597160.png",
            "name": "Wheel_Venn_Diagram",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-3961893789494607964-1624437155247684428/thumbnail.cdn1-3961893789494607964-1624437155247684428.png",
            "canvas_id": "51a7e36837ba830009001034",
            "textbox": [
              {
                "text": "",
                "left": 95.04,
                "top": 163.295984251968,
                "width": 231.370078740157,
                "height": 227.244094488189,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 394.56,
                "top": 189.215984251969,
                "width": 171.842519685039,
                "height": 177.984251968504,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 626.88,
                "top": 163.295984251968,
                "width": 231.370078740157,
                "height": 227.244094488189,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-6833224606629881259-1489379272334225175/cdn1-6833224606629881259-1489379272334225175.png",
            "name": "Wheel_Wheel",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-7877393391803961469-1624437193914756870/thumbnail.cdn1-7877393391803961469-1624437193914756870.png",
            "canvas_id": "51a7e36837ba830009001035",
            "textbox": [
              {
                "text": "",
                "left": 254.4,
                "top": 88.9920472440945,
                "width": 216.944881889764,
                "height": 80.3464566929134,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 254.4,
                "top": 371.52,
                "width": 216.944881889764,
                "height": 80.3464566929134,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 488.64,
                "top": 88.9920472440945,
                "width": 216.944881889764,
                "height": 80.3464566929134,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 488.64,
                "top": 371.52,
                "width": 216.944881889764,
                "height": 80.3464566929134,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 156.48,
                "top": 229.824015748031,
                "width": 188.157480314961,
                "height": 80.3464566929134,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 615.36,
                "top": 229.824015748031,
                "width": 188.157480314961,
                "height": 80.3464566929134,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 395.52,
                "top": 248.832047244094,
                "width": 168,
                "height": 50.1102362204724,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          }
        ],
        "id": "13",
        "free": "False"
      },
      {
        "bundle_cover_image_url": "https://s3.amazonaws.com/drawp-school-canvases-new/wheels/thumbnails/Wheel_Cover_es.png",
        "scale": 1,
        "image_url": "https://s3.amazonaws.com/drawp-school-canvases-new/wheels/Wheel_Cover_es.png",
        "product_id": "WHEELS_CANVAS_BUNDLE",
        "language": "es",
        "bundle_status": 0,
        "bundle_name": "Wheels",
        "canvas_list": [
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-3581674023055375-1489379260310382834/cdn1-3581674023055375-1489379260310382834.png",
            "name": "Wheel_Cluster",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-2899587953188433688-1624436826374138803/thumbnail.cdn1-2899587953188433688-1624436826374138803.png",
            "canvas_id": "51a7e35637ba83000a001030",
            "textbox": [
              {
                "text": "",
                "left": 48,
                "top": 30.24,
                "width": 118.07874015748,
                "height": 47.5275590551181,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 267.84,
                "top": 30.24,
                "width": 118.07874015748,
                "height": 47.5275590551181,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 574.08,
                "top": 30.24,
                "width": 118.07874015748,
                "height": 47.5275590551181,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 793.92,
                "top": 30.24,
                "width": 118.07874015748,
                "height": 47.5275590551181,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 127.68,
                "top": 119.232047244094,
                "width": 176.629921259843,
                "height": 69.1338582677165,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 658.56,
                "top": 119.232047244094,
                "width": 176.629921259843,
                "height": 69.1338582677165,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 330.24,
                "top": 235.872047244094,
                "width": 298.551181102362,
                "height": 69.1338582677165,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 127.68,
                "top": 351.647952755906,
                "width": 176.629921259843,
                "height": 69.1338582677165,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 658.56,
                "top": 351.647952755906,
                "width": 176.629921259843,
                "height": 69.1338582677165,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 48,
                "top": 462.24,
                "width": 118.07874015748,
                "height": 47.5275590551181,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 267.84,
                "top": 462.24,
                "width": 118.07874015748,
                "height": 47.5275590551181,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 574.08,
                "top": 462.24,
                "width": 118.07874015748,
                "height": 47.5275590551181,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 793.92,
                "top": 462.24,
                "width": 118.07874015748,
                "height": 47.5275590551181,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-1469168669401456793-1489379396358224050/cdn1-1469168669401456793-1489379396358224050.png",
            "name": "Wheel_Goal_Reason_es",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-145967910182675917-1624436915660956385/thumbnail.cdn1-145967910182675917-1624436915660956385.png",
            "canvas_id": "51a7e36837ba830009001031",
            "textbox": [
              {
                "text": "",
                "left": 368.64,
                "top": 60.48,
                "width": 222.708661417323,
                "height": 110.582677165354,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 125.76,
                "top": 228.96,
                "width": 222.708661417323,
                "height": 110.582677165354,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 610.56,
                "top": 228.96,
                "width": 222.708661417323,
                "height": 110.582677165354,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 32.64,
                "top": 425.952047244095,
                "width": 148.787401574803,
                "height": 82.9291338582677,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 296.64,
                "top": 425.952047244095,
                "width": 148.787401574803,
                "height": 82.9291338582677,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 516.48,
                "top": 425.952047244095,
                "width": 148.787401574803,
                "height": 82.9291338582677,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 779.52,
                "top": 425.952047244095,
                "width": 148.787401574803,
                "height": 82.9291338582677,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-4786323883654641863-1489379265240295692/cdn1-4786323883654641863-1489379265240295692.png",
            "name": "Wheel_Idea",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-3393971523427801160-1624436968400083135/thumbnail.cdn1-3393971523427801160-1624436968400083135.png",
            "canvas_id": "51a7e37b37ba830009001032",
            "textbox": [
              {
                "text": "",
                "left": 208.32,
                "top": 108.864015748031,
                "width": 263.055118110236,
                "height": 154.645669291339,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 487.68,
                "top": 108.864015748031,
                "width": 263.055118110236,
                "height": 154.645669291339,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 208.32,
                "top": 273.887952755906,
                "width": 263.055118110236,
                "height": 154.645669291339,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 487.68,
                "top": 273.887952755906,
                "width": 263.055118110236,
                "height": 154.645669291339,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-3757002111408494023-1489379267718463005/cdn1-3757002111408494023-1489379267718463005.png",
            "name": "Wheel_MAp",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-253131366265868552-1624437110604298003/thumbnail.cdn1-253131366265868552-1624437110604298003.png",
            "canvas_id": "51a7e36837ba830009001033",
            "textbox": [
              {
                "text": "",
                "left": 78.72,
                "top": 138.24,
                "width": 231.370078740157,
                "height": 79.496062992126,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 78.72,
                "top": 301.535984251969,
                "width": 231.370078740157,
                "height": 79.496062992126,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 364.8,
                "top": 50.9759842519685,
                "width": 263.055118110236,
                "height": 79.496062992126,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 364.8,
                "top": 222.912047244094,
                "width": 263.055118110236,
                "height": 79.496062992126,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 364.8,
                "top": 406.08,
                "width": 263.055118110236,
                "height": 79.496062992126,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 655.68,
                "top": 138.24,
                "width": 231.370078740157,
                "height": 79.496062992126,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 655.68,
                "top": 301.535984251969,
                "width": 231.370078740157,
                "height": 79.496062992126,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-7762828229455116518-1489379269949654371/cdn1-7762828229455116518-1489379269949654371.png",
            "name": "Wheel_Venn_Diagram",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-3961893789494607964-1624437155247684428/thumbnail.cdn1-3961893789494607964-1624437155247684428.png",
            "canvas_id": "51a7e36837ba830009001034",
            "textbox": [
              {
                "text": "",
                "left": 95.04,
                "top": 163.295984251968,
                "width": 231.370078740157,
                "height": 227.244094488189,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 394.56,
                "top": 189.215984251969,
                "width": 171.842519685039,
                "height": 177.984251968504,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 626.88,
                "top": 163.295984251968,
                "width": 231.370078740157,
                "height": 227.244094488189,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          },
          {
            "datastore_url": "https://cdn1.drawpforschool.com/assets/cdn1-9108807545427058795-1489379396722188496/cdn1-9108807545427058795-1489379396722188496.png",
            "name": "Wheel_Wheel_es",
            "tp": "https://cdn1.drawpforschool.com/assets/cdn1-2646003955019191041-1624437222132156684/thumbnail.cdn1-2646003955019191041-1624437222132156684.png",
            "canvas_id": "51a7e36837ba830009001035",
            "textbox": [
              {
                "text": "",
                "left": 254.4,
                "top": 88.9920472440945,
                "width": 216.944881889764,
                "height": 80.3464566929134,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 254.4,
                "top": 371.52,
                "width": 216.944881889764,
                "height": 80.3464566929134,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 488.64,
                "top": 88.9920472440945,
                "width": 216.944881889764,
                "height": 80.3464566929134,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 488.64,
                "top": 371.52,
                "width": 216.944881889764,
                "height": 80.3464566929134,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 156.48,
                "top": 229.824015748031,
                "width": 188.157480314961,
                "height": 80.3464566929134,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 615.36,
                "top": 229.824015748031,
                "width": 188.157480314961,
                "height": 80.3464566929134,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              },
              {
                "text": "",
                "left": 395.52,
                "top": 248.832047244094,
                "width": 168,
                "height": 50.1102362204724,
                "borderColor": "#666666",
                "borderWidth": 1,
                "borderStyle": "Dash",
                "alignment": "Left",
                "fontName": "Calibri",
                "fontSize": 24,
                "bold": false,
                "italic": false,
                "color": "#44546A"
              }
            ]
          }
        ],
        "id": "13",
        "free": "False"
      }
    ]
  }

}

export { getGraphicOrganizerData };